import { colors } from 'src/themes/default';

export const WaitingForCarrierOkIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173967)">
            <path
                d="M0.464844 21C0.464844 9.40202 9.86686 0 21.4648 0V0C33.0628 0 42.4648 9.40202 42.4648 21V21C42.4648 32.598 33.0628 42 21.4648 42V42C9.86686 42 0.464844 32.598 0.464844 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.4648" cy="21" r="20" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M24.3046 27.52H18.6246L18.1846 26.52L20.3046 24.04C20.5846 23.72 21.0246 23.52 21.4646 23.52C21.9046 23.52 22.3446 23.72 22.6246 24.04L24.7446 26.52L24.3046 27.52ZM19.9446 26.32H23.0246L21.7446 24.8C21.6246 24.68 21.3446 24.68 21.2646 24.8L19.9446 26.32Z"
            fill={colors.primary_O}
        />
        <path d="M24.5041 19.0401H18.3841L17.7041 17.8401H25.3041L24.5041 19.0401Z" fill={colors.primary_O} />
        <path
            d="M16.0645 12V12.6V15.08C16.0645 18.12 18.6645 20.08 20.1845 21C18.6645 21.88 16.0645 23.88 16.0645 26.92V29.4V30H26.8645V29.4V26.92C26.8645 23.88 24.2645 21.92 22.7445 21C24.2645 20.12 26.8645 18.12 26.8645 15.08V12.6V12H16.0645ZM17.2645 13.2H25.6645V14.48H17.2645V13.2ZM25.6645 28.8H17.2645V27.52H25.6645V28.8ZM25.6245 26.32H17.3045C17.7045 23.72 20.5845 22.12 21.4645 21.68C22.3045 22.08 25.2245 23.72 25.6245 26.32ZM21.4645 20.32C20.6245 19.88 17.7045 18.24 17.3045 15.68H25.6245C25.2245 18.28 22.3045 19.92 21.4645 20.32Z"
            fill={colors.icon}
        />
        <path
            d="M27.9843 17.52L26.9443 18.08C27.4243 18.96 27.6643 20 27.6643 21C27.6643 22 27.4243 23.04 26.9443 23.92L27.9843 24.48C28.5443 23.4 28.8643 22.2 28.8643 21C28.8643 19.8 28.5443 18.6 27.9843 17.52Z"
            fill={colors.icon}
        />
        <path
            d="M14.9445 17.52C14.3845 18.6 14.0645 19.8 14.0645 21C14.0645 22.2 14.3845 23.4 14.9445 24.48L15.9845 23.92C15.5045 23.04 15.2645 22 15.2645 21C15.2645 20 15.5045 18.96 15.9845 18.08L14.9445 17.52Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173967">
                <path
                    d="M0.464844 21C0.464844 9.40202 9.86686 0 21.4648 0V0C33.0628 0 42.4648 9.40202 42.4648 21V21C42.4648 32.598 33.0628 42 21.4648 42V42C9.86686 42 0.464844 32.598 0.464844 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierOkBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173965)">
            <path
                d="M0.793945 28C0.793945 12.536 13.33 0 28.7939 0V0C44.2579 0 56.7939 12.536 56.7939 28V28C56.7939 43.464 44.2579 56 28.7939 56V56C13.33 56 0.793945 43.464 0.793945 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.7939" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M32.5809 36.6934H25.0076L24.4209 35.3601L27.2476 32.0534C27.6209 31.6268 28.2076 31.3601 28.7942 31.3601C29.3809 31.3601 29.9676 31.6268 30.3409 32.0534L33.1676 35.3601L32.5809 36.6934ZM26.7676 35.0934H30.8742L29.1676 33.0668C29.0076 32.9068 28.6342 32.9068 28.5276 33.0668L26.7676 35.0934Z"
            fill={colors.primary_O}
        />
        <path d="M32.8479 25.3866H24.6879L23.7812 23.7866H33.9146L32.8479 25.3866Z" fill={colors.primary_O} />
        <path
            d="M21.5947 16V16.8V20.1067C21.5947 24.16 25.0614 26.7733 27.0881 28C25.0614 29.1733 21.5947 31.84 21.5947 35.8933V39.2V40H35.9947V39.2V35.8933C35.9947 31.84 32.5281 29.2267 30.5014 28C32.5281 26.8267 35.9947 24.16 35.9947 20.1067V16.8V16H21.5947ZM23.1947 17.6H34.3947V19.3067H23.1947V17.6ZM34.3947 38.4H23.1947V36.6933H34.3947V38.4ZM34.3414 35.0933H23.2481C23.7814 31.6267 27.6214 29.4933 28.7947 28.9067C29.9147 29.44 33.8081 31.6267 34.3414 35.0933ZM28.7947 27.0933C27.6747 26.5067 23.7814 24.32 23.2481 20.9067H34.3414C33.8081 24.3733 29.9147 26.56 28.7947 27.0933Z"
            fill={colors.icon}
        />
        <path
            d="M37.4873 23.3601L36.1006 24.1068C36.7406 25.2801 37.0606 26.6668 37.0606 28.0001C37.0606 29.3334 36.7406 30.7201 36.1006 31.8934L37.4873 32.6401C38.2339 31.2001 38.6606 29.6001 38.6606 28.0001C38.6606 26.4001 38.2339 24.8001 37.4873 23.3601Z"
            fill={colors.icon}
        />
        <path
            d="M20.1011 23.3601C19.3544 24.8001 18.9277 26.4001 18.9277 28.0001C18.9277 29.6001 19.3544 31.2001 20.1011 32.6401L21.4877 31.8934C20.8477 30.7201 20.5277 29.3334 20.5277 28.0001C20.5277 26.6668 20.8477 25.2801 21.4877 24.1068L20.1011 23.3601Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173965">
                <path
                    d="M0.793945 28C0.793945 12.536 13.33 0 28.7939 0V0C44.2579 0 56.7939 12.536 56.7939 28V28C56.7939 43.464 44.2579 56 28.7939 56V56C13.33 56 0.793945 43.464 0.793945 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierOkWithWarningBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173965)">
            <path
                d="M0.793945 28C0.793945 12.536 13.33 0 28.7939 0V0C44.2579 0 56.7939 12.536 56.7939 28V28C56.7939 43.464 44.2579 56 28.7939 56V56C13.33 56 0.793945 43.464 0.793945 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.7939" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M32.5809 36.6934H25.0076L24.4209 35.3601L27.2476 32.0534C27.6209 31.6268 28.2076 31.3601 28.7942 31.3601C29.3809 31.3601 29.9676 31.6268 30.3409 32.0534L33.1676 35.3601L32.5809 36.6934ZM26.7676 35.0934H30.8742L29.1676 33.0668C29.0076 32.9068 28.6342 32.9068 28.5276 33.0668L26.7676 35.0934Z"
            fill={colors.primary_O}
        />
        <path d="M32.8479 25.3866H24.6879L23.7812 23.7866H33.9146L32.8479 25.3866Z" fill={colors.primary_O} />
        <path
            d="M21.5947 16V16.8V20.1067C21.5947 24.16 25.0614 26.7733 27.0881 28C25.0614 29.1733 21.5947 31.84 21.5947 35.8933V39.2V40H35.9947V39.2V35.8933C35.9947 31.84 32.5281 29.2267 30.5014 28C32.5281 26.8267 35.9947 24.16 35.9947 20.1067V16.8V16H21.5947ZM23.1947 17.6H34.3947V19.3067H23.1947V17.6ZM34.3947 38.4H23.1947V36.6933H34.3947V38.4ZM34.3414 35.0933H23.2481C23.7814 31.6267 27.6214 29.4933 28.7947 28.9067C29.9147 29.44 33.8081 31.6267 34.3414 35.0933ZM28.7947 27.0933C27.6747 26.5067 23.7814 24.32 23.2481 20.9067H34.3414C33.8081 24.3733 29.9147 26.56 28.7947 27.0933Z"
            fill={colors.icon}
        />
        <path
            d="M37.4873 23.3601L36.1006 24.1068C36.7406 25.2801 37.0606 26.6668 37.0606 28.0001C37.0606 29.3334 36.7406 30.7201 36.1006 31.8934L37.4873 32.6401C38.2339 31.2001 38.6606 29.6001 38.6606 28.0001C38.6606 26.4001 38.2339 24.8001 37.4873 23.3601Z"
            fill={colors.icon}
        />
        <path
            d="M20.1011 23.3601C19.3544 24.8001 18.9277 26.4001 18.9277 28.0001C18.9277 29.6001 19.3544 31.2001 20.1011 32.6401L21.4877 31.8934C20.8477 30.7201 20.5277 29.3334 20.5277 28.0001C20.5277 26.6668 20.8477 25.2801 21.4877 24.1068L20.1011 23.3601Z"
            fill={colors.icon}
        />
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_173965">
                <path
                    d="M0.793945 28C0.793945 12.536 13.33 0 28.7939 0V0C44.2579 0 56.7939 12.536 56.7939 28V28C56.7939 43.464 44.2579 56 28.7939 56V56C13.33 56 0.793945 43.464 0.793945 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierDisabledIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173993)">
            <path
                d="M0.177734 21C0.177734 9.40202 9.57975 0 21.1777 0V0C32.7757 0 42.1777 9.40202 42.1777 21V21C42.1777 32.598 32.7757 42 21.1777 42V42C9.57975 42 0.177734 32.598 0.177734 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.1777" cy="21" r="21" fill="#F8F9FE" />
        </g>
        <path
            d="M24.0175 27.52H18.3375L17.8975 26.52L20.0175 24.04C20.2975 23.72 20.7375 23.52 21.1775 23.52C21.6175 23.52 22.0575 23.72 22.3375 24.04L24.4575 26.52L24.0175 27.52ZM19.6575 26.32H22.7375L21.4575 24.8C21.3375 24.68 21.0575 24.68 20.9775 24.8L19.6575 26.32Z"
            fill="#7E8CB2"
        />
        <path d="M24.217 19.0401H18.097L17.417 17.8401H25.017L24.217 19.0401Z" fill="#7E8CB2" />
        <path
            d="M15.7773 12V12.6V15.08C15.7773 18.12 18.3773 20.08 19.8973 21C18.3773 21.88 15.7773 23.88 15.7773 26.92V29.4V30H26.5773V29.4V26.92C26.5773 23.88 23.9773 21.92 22.4573 21C23.9773 20.12 26.5773 18.12 26.5773 15.08V12.6V12H15.7773ZM16.9773 13.2H25.3773V14.48H16.9773V13.2ZM25.3773 28.8H16.9773V27.52H25.3773V28.8ZM25.3373 26.32H17.0173C17.4173 23.72 20.2973 22.12 21.1773 21.68C22.0173 22.08 24.9373 23.72 25.3373 26.32ZM21.1773 20.32C20.3373 19.88 17.4173 18.24 17.0173 15.68H25.3373C24.9373 18.28 22.0173 19.92 21.1773 20.32Z"
            fill="#7E8CB2"
        />
        <path
            d="M27.6972 17.52L26.6572 18.08C27.1372 18.96 27.3772 20 27.3772 21C27.3772 22 27.1372 23.04 26.6572 23.92L27.6972 24.48C28.2572 23.4 28.5772 22.2 28.5772 21C28.5772 19.8 28.2572 18.6 27.6972 17.52Z"
            fill="#7E8CB2"
        />
        <path
            d="M14.6573 17.52C14.0973 18.6 13.7773 19.8 13.7773 21C13.7773 22.2 14.0973 23.4 14.6573 24.48L15.6973 23.92C15.2173 23.04 14.9773 22 14.9773 21C14.9773 20 15.2173 18.96 15.6973 18.08L14.6573 17.52Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_173993">
                <path
                    d="M0.177734 21C0.177734 9.40202 9.57975 0 21.1777 0V0C32.7757 0 42.1777 9.40202 42.1777 21V21C42.1777 32.598 32.7757 42 21.1777 42V42C9.57975 42 0.177734 32.598 0.177734 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierDisabledBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173991)">
            <path
                d="M0.506836 28C0.506836 12.536 13.0429 0 28.5068 0V0C43.9708 0 56.5068 12.536 56.5068 28V28C56.5068 43.464 43.9708 56 28.5068 56V56C13.0429 56 0.506836 43.464 0.506836 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.5068" cy="28" r="28" fill="#F8F9FE" />
        </g>
        <path
            d="M32.2938 36.6934H24.7205L24.1338 35.3601L26.9605 32.0534C27.3338 31.6268 27.9205 31.3601 28.5071 31.3601C29.0938 31.3601 29.6805 31.6268 30.0538 32.0534L32.8805 35.3601L32.2938 36.6934ZM26.4805 35.0934H30.5871L28.8805 33.0668C28.7205 32.9068 28.3471 32.9068 28.2405 33.0668L26.4805 35.0934Z"
            fill="#7E8CB2"
        />
        <path d="M32.5608 25.3866H24.4008L23.4941 23.7866H33.6275L32.5608 25.3866Z" fill="#7E8CB2" />
        <path
            d="M21.3076 16V16.8V20.1067C21.3076 24.16 24.7743 26.7733 26.801 28C24.7743 29.1733 21.3076 31.84 21.3076 35.8933V39.2V40H35.7076V39.2V35.8933C35.7076 31.84 32.241 29.2267 30.2143 28C32.241 26.8267 35.7076 24.16 35.7076 20.1067V16.8V16H21.3076ZM22.9076 17.6H34.1076V19.3067H22.9076V17.6ZM34.1076 38.4H22.9076V36.6933H34.1076V38.4ZM34.0543 35.0933H22.961C23.4943 31.6267 27.3343 29.4933 28.5076 28.9067C29.6276 29.44 33.521 31.6267 34.0543 35.0933ZM28.5076 27.0933C27.3876 26.5067 23.4943 24.32 22.961 20.9067H34.0543C33.521 24.3733 29.6276 26.56 28.5076 27.0933Z"
            fill="#7E8CB2"
        />
        <path
            d="M37.2001 23.3601L35.8135 24.1068C36.4535 25.2801 36.7735 26.6668 36.7735 28.0001C36.7735 29.3334 36.4535 30.7201 35.8135 31.8934L37.2001 32.6401C37.9468 31.2001 38.3735 29.6001 38.3735 28.0001C38.3735 26.4001 37.9468 24.8001 37.2001 23.3601Z"
            fill="#7E8CB2"
        />
        <path
            d="M19.814 23.3601C19.0673 24.8001 18.6406 26.4001 18.6406 28.0001C18.6406 29.6001 19.0673 31.2001 19.814 32.6401L21.2006 31.8934C20.5606 30.7201 20.2406 29.3334 20.2406 28.0001C20.2406 26.6668 20.5606 25.2801 21.2006 24.1068L19.814 23.3601Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_173991">
                <path
                    d="M0.506836 28C0.506836 12.536 13.0429 0 28.5068 0V0C43.9708 0 56.5068 12.536 56.5068 28V28C56.5068 43.464 43.9708 56 28.5068 56V56C13.0429 56 0.506836 43.464 0.506836 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierErrorIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174056)">
            <path
                d="M0.603516 22C0.603516 10.402 10.0055 1 21.6035 1V1C33.2015 1 42.6035 10.402 42.6035 22V22C42.6035 33.598 33.2015 43 21.6035 43V43C10.0055 43 0.603516 33.598 0.603516 22V22Z"
                fill="#F9675D"
            />
            <circle cx="21.6035" cy="22" r="20" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M24.4432 28.52H18.7632L18.3232 27.52L20.4432 25.04C20.7232 24.72 21.1632 24.52 21.6032 24.52C22.0432 24.52 22.4832 24.72 22.7632 25.04L24.8832 27.52L24.4432 28.52ZM20.0832 27.32H23.1632L21.8832 25.8C21.7632 25.68 21.4832 25.68 21.4032 25.8L20.0832 27.32Z"
            fill="#F9675D"
        />
        <path d="M24.6428 20.0401H18.5228L17.8428 18.8401H25.4428L24.6428 20.0401Z" fill="#F9675D" />
        <path
            d="M16.2031 13V13.6V16.08C16.2031 19.12 18.8031 21.08 20.3231 22C18.8031 22.88 16.2031 24.88 16.2031 27.92V30.4V31H27.0031V30.4V27.92C27.0031 24.88 24.4031 22.92 22.8831 22C24.4031 21.12 27.0031 19.12 27.0031 16.08V13.6V13H16.2031ZM17.4031 14.2H25.8031V15.48H17.4031V14.2ZM25.8031 29.8H17.4031V28.52H25.8031V29.8ZM25.7631 27.32H17.4431C17.8431 24.72 20.7231 23.12 21.6031 22.68C22.4431 23.08 25.3631 24.72 25.7631 27.32ZM21.6031 21.32C20.7631 20.88 17.8431 19.24 17.4431 16.68H25.7631C25.3631 19.28 22.4431 20.92 21.6031 21.32Z"
            fill="#F9675D"
        />
        <path
            d="M28.123 18.52L27.083 19.08C27.563 19.96 27.803 21 27.803 22C27.803 23 27.563 24.04 27.083 24.92L28.123 25.48C28.683 24.4 29.003 23.2 29.003 22C29.003 20.8 28.683 19.6 28.123 18.52Z"
            fill="#F9675D"
        />
        <path
            d="M15.0831 18.52C14.5231 19.6 14.2031 20.8 14.2031 22C14.2031 23.2 14.5231 24.4 15.0831 25.48L16.1231 24.92C15.6431 24.04 15.4031 23 15.4031 22C15.4031 21 15.6431 19.96 16.1231 19.08L15.0831 18.52Z"
            fill="#F9675D"
        />
        <circle cx="33.6035" cy="9" r="9" fill="#F9675D" />
        <path
            d="M33.996 2.23193H33.268L27.668 13.4319L28.06 14.0479H39.26L39.652 13.4319L33.996 2.23193ZM28.676 13.2079L33.604 3.35193L38.532 13.2079H28.676Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M34.0519 6.26392H33.2119V10.1839H34.0519V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M34.1076 11.136H33.0996V12.144H34.1076V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174056">
                <path
                    d="M0.603516 22C0.603516 10.402 10.0055 1 21.6035 1V1C33.2015 1 42.6035 10.402 42.6035 22V22C42.6035 33.598 33.2015 43 21.6035 43V43C10.0055 43 0.603516 33.598 0.603516 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierErrorBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174053)">
            <path
                d="M0.931641 29C0.931641 13.536 13.4677 1 28.9316 1V1C44.3956 1 56.9316 13.536 56.9316 29V29C56.9316 44.464 44.3956 57 28.9316 57V57C13.4677 57 0.931641 44.464 0.931641 29V29Z"
                fill="#F9675D"
            />
            <circle cx="28.9316" cy="29" r="27" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M32.7186 37.6934H25.1453L24.5586 36.3601L27.3853 33.0534C27.7586 32.6268 28.3453 32.3601 28.9319 32.3601C29.5186 32.3601 30.1053 32.6268 30.4786 33.0534L33.3053 36.3601L32.7186 37.6934ZM26.9053 36.0934H31.0119L29.3053 34.0668C29.1453 33.9068 28.7719 33.9068 28.6653 34.0668L26.9053 36.0934Z"
            fill="#F9675D"
        />
        <path d="M32.9856 26.3866H24.8256L23.9189 24.7866H34.0523L32.9856 26.3866Z" fill="#F9675D" />
        <path
            d="M21.7324 17V17.8V21.1067C21.7324 25.16 25.1991 27.7733 27.2258 29C25.1991 30.1733 21.7324 32.84 21.7324 36.8933V40.2V41H36.1324V40.2V36.8933C36.1324 32.84 32.6658 30.2267 30.6391 29C32.6658 27.8267 36.1324 25.16 36.1324 21.1067V17.8V17H21.7324ZM23.3324 18.6H34.5324V20.3067H23.3324V18.6ZM34.5324 39.4H23.3324V37.6933H34.5324V39.4ZM34.4791 36.0933H23.3858C23.9191 32.6267 27.7591 30.4933 28.9324 29.9067C30.0524 30.44 33.9458 32.6267 34.4791 36.0933ZM28.9324 28.0933C27.8124 27.5067 23.9191 25.32 23.3858 21.9067H34.4791C33.9458 25.3733 30.0524 27.56 28.9324 28.0933Z"
            fill="#F9675D"
        />
        <path
            d="M37.6249 24.3601L36.2383 25.1068C36.8783 26.2801 37.1983 27.6668 37.1983 29.0001C37.1983 30.3334 36.8783 31.7201 36.2383 32.8934L37.6249 33.6401C38.3716 32.2001 38.7983 30.6001 38.7983 29.0001C38.7983 27.4001 38.3716 25.8001 37.6249 24.3601Z"
            fill="#F9675D"
        />
        <path
            d="M20.2388 24.3601C19.4921 25.8001 19.0654 27.4001 19.0654 29.0001C19.0654 30.6001 19.4921 32.2001 20.2388 33.6401L21.6254 32.8934C20.9854 31.7201 20.6654 30.3334 20.6654 29.0001C20.6654 27.6668 20.9854 26.2801 21.6254 25.1068L20.2388 24.3601Z"
            fill="#F9675D"
        />
        <circle cx="47.9316" cy="9" r="9" fill="#F9675D" />
        <g clipPath="url(#clip1_13649_174053)">
            <path
                d="M48.3241 2.23193H47.5961L41.9961 13.4319L42.3881 14.0479H53.5881L53.9801 13.4319L48.3241 2.23193ZM43.0041 13.2079L47.9321 3.35193L52.8601 13.2079H43.0041Z"
                fill="white"
                stroke="white"
                strokeWidth="0.2"
            />
            <path d="M48.38 6.26392H47.54V10.1839H48.38V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
            <path d="M48.4357 11.136H47.4277V12.144H48.4357V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        </g>
        <defs>
            <clipPath id="clip0_13649_174053">
                <path
                    d="M0.931641 29C0.931641 13.536 13.4677 1 28.9316 1V1C44.3956 1 56.9316 13.536 56.9316 29V29C56.9316 44.464 44.3956 57 28.9316 57V57C13.4677 57 0.931641 44.464 0.931641 29V29Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174053">
                <rect width="14" height="14" fill="white" transform="translate(40.9316 1)" />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierWarningIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174090)">
            <path
                d="M0.314453 22C0.314453 10.402 9.71647 1 21.3145 1V1C32.9124 1 42.3145 10.402 42.3145 22V22C42.3145 33.598 32.9124 43 21.3145 43V43C9.71647 43 0.314453 33.598 0.314453 22V22Z"
                fill="#ED9937"
            />
            <circle cx="21.3145" cy="22" r="20" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M24.1542 28.52H18.4742L18.0342 27.52L20.1542 25.04C20.4342 24.72 20.8742 24.52 21.3142 24.52C21.7542 24.52 22.1942 24.72 22.4742 25.04L24.5942 27.52L24.1542 28.52ZM19.7942 27.32H22.8742L21.5942 25.8C21.4742 25.68 21.1942 25.68 21.1142 25.8L19.7942 27.32Z"
            fill="#ED9937"
        />
        <path d="M24.3537 20.0401H18.2337L17.5537 18.8401H25.1537L24.3537 20.0401Z" fill="#ED9937" />
        <path
            d="M15.9141 13V13.6V16.08C15.9141 19.12 18.5141 21.08 20.0341 22C18.5141 22.88 15.9141 24.88 15.9141 27.92V30.4V31H26.7141V30.4V27.92C26.7141 24.88 24.1141 22.92 22.5941 22C24.1141 21.12 26.7141 19.12 26.7141 16.08V13.6V13H15.9141ZM17.1141 14.2H25.5141V15.48H17.1141V14.2ZM25.5141 29.8H17.1141V28.52H25.5141V29.8ZM25.4741 27.32H17.1541C17.5541 24.72 20.4341 23.12 21.3141 22.68C22.1541 23.08 25.0741 24.72 25.4741 27.32ZM21.3141 21.32C20.4741 20.88 17.5541 19.24 17.1541 16.68H25.4741C25.0741 19.28 22.1541 20.92 21.3141 21.32Z"
            fill="#ED9937"
        />
        <path
            d="M27.8339 18.52L26.7939 19.08C27.2739 19.96 27.5139 21 27.5139 22C27.5139 23 27.2739 24.04 26.7939 24.92L27.8339 25.48C28.3939 24.4 28.7139 23.2 28.7139 22C28.7139 20.8 28.3939 19.6 27.8339 18.52Z"
            fill="#ED9937"
        />
        <path
            d="M14.7941 18.52C14.2341 19.6 13.9141 20.8 13.9141 22C13.9141 23.2 14.2341 24.4 14.7941 25.48L15.8341 24.92C15.3541 24.04 15.1141 23 15.1141 22C15.1141 21 15.3541 19.96 15.8341 19.08L14.7941 18.52Z"
            fill="#ED9937"
        />
        <circle cx="35.5645" cy="7" r="6.75" fill="#FFB865" />
        <path
            d="M37.9581 5.87203C37.9581 4.52804 36.8661 3.43604 35.5221 3.43604C34.1781 3.43604 33.0861 4.52804 33.0861 5.87203V7.63603H32.0781V10.576H39.0081V7.63603H37.9581V5.87203ZM33.7581 5.87203C33.7581 4.90604 34.5561 4.10804 35.5221 4.10804C36.4881 4.10804 37.2861 4.90604 37.2861 5.87203V7.63603H33.7581V5.87203ZM38.3781 8.30803V9.98803H32.7501V8.30803H33.1701H38.0001H38.3781Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M35.9005 1.88208H35.2705V2.93208H35.9005V1.88208Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M39.7639 5.78809H38.7139V6.41809H39.7639V5.78809Z" fill="#623602" />
        <path d="M32.4143 5.78809H31.3643V6.41809H32.4143V5.78809Z" fill="#623602" />
        <path d="M38.5139 2.72214L37.7715 3.4646L38.217 3.91007L38.9594 3.16762L38.5139 2.72214Z" fill="#623602" />
        <path d="M32.6388 2.74203L32.1934 3.1875L32.9358 3.92996L33.3813 3.48448L32.6388 2.74203Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174090">
                <path
                    d="M0.314453 22C0.314453 10.402 9.71647 1 21.3145 1V1C32.9124 1 42.3145 10.402 42.3145 22V22C42.3145 33.598 32.9124 43 21.3145 43V43C9.71647 43 0.314453 33.598 0.314453 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174087)">
            <path
                d="M0.643555 29C0.643555 13.536 13.1796 1 28.6436 1V1C44.1075 1 56.6436 13.536 56.6436 29V29C56.6436 44.464 44.1075 57 28.6436 57V57C13.1796 57 0.643555 44.464 0.643555 29V29Z"
                fill="#ED9937"
            />
            <circle cx="28.6436" cy="29" r="27" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M32.4305 37.6934H24.8572L24.2705 36.3601L27.0972 33.0534C27.4705 32.6268 28.0572 32.3601 28.6438 32.3601C29.2305 32.3601 29.8172 32.6268 30.1905 33.0534L33.0172 36.3601L32.4305 37.6934ZM26.6172 36.0934H30.7238L29.0172 34.0668C28.8572 33.9068 28.4838 33.9068 28.3772 34.0668L26.6172 36.0934Z"
            fill="#ED9937"
        />
        <path d="M32.6975 26.3866H24.5375L23.6309 24.7866H33.7642L32.6975 26.3866Z" fill="#ED9937" />
        <path
            d="M21.4443 17V17.8V21.1067C21.4443 25.16 24.911 27.7733 26.9377 29C24.911 30.1733 21.4443 32.84 21.4443 36.8933V40.2V41H35.8443V40.2V36.8933C35.8443 32.84 32.3777 30.2267 30.351 29C32.3777 27.8267 35.8443 25.16 35.8443 21.1067V17.8V17H21.4443ZM23.0443 18.6H34.2443V20.3067H23.0443V18.6ZM34.2443 39.4H23.0443V37.6933H34.2443V39.4ZM34.191 36.0933H23.0977C23.631 32.6267 27.471 30.4933 28.6443 29.9067C29.7643 30.44 33.6577 32.6267 34.191 36.0933ZM28.6443 28.0933C27.5243 27.5067 23.631 25.32 23.0977 21.9067H34.191C33.6577 25.3733 29.7643 27.56 28.6443 28.0933Z"
            fill="#ED9937"
        />
        <path
            d="M37.3369 24.3601L35.9502 25.1068C36.5902 26.2801 36.9102 27.6668 36.9102 29.0001C36.9102 30.3334 36.5902 31.7201 35.9502 32.8934L37.3369 33.6401C38.0835 32.2001 38.5102 30.6001 38.5102 29.0001C38.5102 27.4001 38.0835 25.8001 37.3369 24.3601Z"
            fill="#ED9937"
        />
        <path
            d="M19.9507 24.3601C19.204 25.8001 18.7773 27.4001 18.7773 29.0001C18.7773 30.6001 19.204 32.2001 19.9507 33.6401L21.3373 32.8934C20.6973 31.7201 20.3773 30.3334 20.3773 29.0001C20.3773 27.6668 20.6973 26.2801 21.3373 25.1068L19.9507 24.3601Z"
            fill="#ED9937"
        />
        <circle cx="47.6436" cy="9" r="9" fill="#FFB865" />
        <path
            d="M50.8361 7.49605C50.8361 5.70405 49.3801 4.24805 47.5881 4.24805C45.7961 4.24805 44.3401 5.70405 44.3401 7.49605V9.84805H42.9961V13.768H52.2361V9.84805H50.8361V7.49605ZM45.2361 7.49605C45.2361 6.20805 46.3001 5.14405 47.5881 5.14405C48.8761 5.14405 49.9401 6.20805 49.9401 7.49605V9.84805H45.2361V7.49605ZM51.3961 10.744V12.984H43.8921V10.744H44.4521H50.8921H51.3961Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M48.092 2.17603H47.252V3.57603H48.092V2.17603Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M53.2438 7.38403H51.8438V8.22403H53.2438V7.38403Z" fill="#623602" />
        <path d="M43.4439 7.38403H42.0439V8.22403H43.4439V7.38403Z" fill="#623602" />
        <path d="M51.5769 3.29595L50.5869 4.28589L51.1809 4.87985L52.1708 3.88991L51.5769 3.29595Z" fill="#623602" />
        <path d="M43.7434 3.32278L43.1494 3.91675L44.1394 4.90669L44.7333 4.31272L43.7434 3.32278Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174087">
                <path
                    d="M0.643555 29C0.643555 13.536 13.1796 1 28.6436 1V1C44.1075 1 56.6436 13.536 56.6436 29V29C56.6436 44.464 44.1075 57 28.6436 57V57C13.1796 57 0.643555 44.464 0.643555 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierSuccessIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174022)">
            <path
                d="M0.890625 22C0.890625 10.402 10.2926 1 21.8906 1V1C33.4886 1 42.8906 10.402 42.8906 22V22C42.8906 33.598 33.4886 43 21.8906 43V43C10.2926 43 0.890625 33.598 0.890625 22V22Z"
                fill="#93E191"
            />
            <circle cx="21.8906" cy="22" r="20" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M24.7304 28.52H19.0504L18.6104 27.52L20.7304 25.04C21.0104 24.72 21.4504 24.52 21.8904 24.52C22.3304 24.52 22.7704 24.72 23.0504 25.04L25.1704 27.52L24.7304 28.52ZM20.3704 27.32H23.4504L22.1704 25.8C22.0504 25.68 21.7704 25.68 21.6904 25.8L20.3704 27.32Z"
            fill="#54C65F"
        />
        <path d="M24.9299 20.0401H18.8099L18.1299 18.8401H25.7299L24.9299 20.0401Z" fill="#54C65F" />
        <path
            d="M16.4902 13V13.6V16.08C16.4902 19.12 19.0902 21.08 20.6102 22C19.0902 22.88 16.4902 24.88 16.4902 27.92V30.4V31H27.2902V30.4V27.92C27.2902 24.88 24.6902 22.92 23.1702 22C24.6902 21.12 27.2902 19.12 27.2902 16.08V13.6V13H16.4902ZM17.6902 14.2H26.0902V15.48H17.6902V14.2ZM26.0902 29.8H17.6902V28.52H26.0902V29.8ZM26.0502 27.32H17.7302C18.1302 24.72 21.0102 23.12 21.8902 22.68C22.7302 23.08 25.6502 24.72 26.0502 27.32ZM21.8902 21.32C21.0502 20.88 18.1302 19.24 17.7302 16.68H26.0502C25.6502 19.28 22.7302 20.92 21.8902 21.32Z"
            fill="#54C65F"
        />
        <path
            d="M28.4101 18.52L27.3701 19.08C27.8501 19.96 28.0901 21 28.0901 22C28.0901 23 27.8501 24.04 27.3701 24.92L28.4101 25.48C28.9701 24.4 29.2901 23.2 29.2901 22C29.2901 20.8 28.9701 19.6 28.4101 18.52Z"
            fill="#54C65F"
        />
        <path
            d="M15.3702 18.52C14.8102 19.6 14.4902 20.8 14.4902 22C14.4902 23.2 14.8102 24.4 15.3702 25.48L16.4102 24.92C15.9302 24.04 15.6902 23 15.6902 22C15.6902 21 15.9302 19.96 16.4102 19.08L15.3702 18.52Z"
            fill="#54C65F"
        />
        <circle cx="36.1406" cy="7" r="6.75" fill="#54C65F" />
        <path
            d="M39.1109 4.30005L34.7909 8.56605L33.1709 6.94605L32.6309 7.54005L34.7909 9.70005L39.6509 4.84005L39.1109 4.30005Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174022">
                <path
                    d="M0.890625 22C0.890625 10.402 10.2926 1 21.8906 1V1C33.4886 1 42.8906 10.402 42.8906 22V22C42.8906 33.598 33.4886 43 21.8906 43V43C10.2926 43 0.890625 33.598 0.890625 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const WaitingForCarrierSuccessBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174019)">
            <path
                d="M0.219727 29C0.219727 13.536 12.7558 1 28.2197 1V1C43.6837 1 56.2197 13.536 56.2197 29V29C56.2197 44.464 43.6837 57 28.2197 57V57C12.7558 57 0.219727 44.464 0.219727 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.2197" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M32.0067 37.6934H24.4333L23.8467 36.3601L26.6733 33.0534C27.0467 32.6268 27.6333 32.3601 28.22 32.3601C28.8067 32.3601 29.3933 32.6268 29.7667 33.0534L32.5933 36.3601L32.0067 37.6934ZM26.1933 36.0934H30.3L28.5933 34.0668C28.4333 33.9068 28.06 33.9068 27.9533 34.0668L26.1933 36.0934Z"
            fill="#54C65F"
        />
        <path d="M32.2737 26.3866H24.1137L23.207 24.7866H33.3404L32.2737 26.3866Z" fill="#54C65F" />
        <path
            d="M21.0205 17V17.8V21.1067C21.0205 25.16 24.4872 27.7733 26.5138 29C24.4872 30.1733 21.0205 32.84 21.0205 36.8933V40.2V41H35.4205V40.2V36.8933C35.4205 32.84 31.9538 30.2267 29.9272 29C31.9538 27.8267 35.4205 25.16 35.4205 21.1067V17.8V17H21.0205ZM22.6205 18.6H33.8205V20.3067H22.6205V18.6ZM33.8205 39.4H22.6205V37.6933H33.8205V39.4ZM33.7672 36.0933H22.6738C23.2072 32.6267 27.0472 30.4933 28.2205 29.9067C29.3405 30.44 33.2338 32.6267 33.7672 36.0933ZM28.2205 28.0933C27.1005 27.5067 23.2072 25.32 22.6738 21.9067H33.7672C33.2338 25.3733 29.3405 27.56 28.2205 28.0933Z"
            fill="#54C65F"
        />
        <path
            d="M36.913 24.3601L35.5264 25.1068C36.1664 26.2801 36.4864 27.6668 36.4864 29.0001C36.4864 30.3334 36.1664 31.7201 35.5264 32.8934L36.913 33.6401C37.6597 32.2001 38.0864 30.6001 38.0864 29.0001C38.0864 27.4001 37.6597 25.8001 36.913 24.3601Z"
            fill="#54C65F"
        />
        <path
            d="M19.5268 24.3601C18.7802 25.8001 18.3535 27.4001 18.3535 29.0001C18.3535 30.6001 18.7802 32.2001 19.5268 33.6401L20.9135 32.8934C20.2735 31.7201 19.9535 30.3334 19.9535 29.0001C19.9535 27.6668 20.2735 26.2801 20.9135 25.1068L19.5268 24.3601Z"
            fill="#54C65F"
        />
        <circle cx="47.2197" cy="9" r="9" fill="#54C65F" />
        <path
            d="M51.18 5.3999L45.42 11.0879L43.26 8.9279L42.54 9.7199L45.42 12.5999L51.9 6.1199L51.18 5.3999Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174019">
                <path
                    d="M0.219727 29C0.219727 13.536 12.7558 1 28.2197 1V1C43.6837 1 56.2197 13.536 56.2197 29V29C56.2197 44.464 43.6837 57 28.2197 57V57C12.7558 57 0.219727 44.464 0.219727 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredOkIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173975)">
            <path
                d="M0.150391 21C0.150391 9.40202 9.55241 0 21.1504 0V0C32.7484 0 42.1504 9.40202 42.1504 21V21C42.1504 32.598 32.7484 42 21.1504 42V42C9.55241 42 0.150391 32.598 0.150391 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.1504" cy="21" r="20" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M24.6307 19.4401H19.0307H18.4307V12.4401L19.0307 11.8401H24.6307L25.2307 12.4401V19.4401H24.6307ZM19.6307 18.2401H24.0307V13.0401H19.6307V18.2401V18.2401Z"
            fill={colors.primary_O}
        />
        <path
            d="M28.5907 21.1601C28.5507 21.1601 28.5107 21.1601 28.4707 21.1601V11.8401H15.2707V21.8401C14.8307 22.1601 14.4707 22.6001 14.2707 23.1601L11.5107 29.5601L12.6307 30.0401L15.3907 23.6401C15.7107 22.8801 16.4707 22.3601 17.3507 22.3601H23.5507C23.3107 23.0801 22.6307 23.5601 21.8307 23.5601H18.3907V24.7601H21.8307H25.1507L25.5907 24.6001L27.3107 22.8801C27.8707 22.3201 28.7107 22.2001 29.3907 22.5201L25.9107 26.0001C25.3907 26.5201 24.7107 26.8001 23.9907 26.8001H21.6707C19.7107 26.8001 17.9107 27.8401 16.8707 29.4801L17.9107 30.1201C18.7107 28.8001 20.1507 28.0001 21.6707 28.0001H23.9907C25.0307 28.0001 25.9907 27.6001 26.7507 26.8401L30.7507 22.8401V22.0001C30.1507 21.4801 29.3907 21.1601 28.5907 21.1601ZM24.9107 23.5601H24.2307C24.6307 23.0401 24.8307 22.4401 24.8307 21.7601L24.2307 21.1601H17.2707C16.9907 21.1601 16.7107 21.2001 16.4307 21.2801V13.0401H27.2307V21.4801C26.9507 21.6401 26.6707 21.8001 26.4307 22.0401L24.9107 23.5601Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173975">
                <path
                    d="M0.150391 21C0.150391 9.40202 9.55241 0 21.1504 0V0C32.7484 0 42.1504 9.40202 42.1504 21V21C42.1504 32.598 32.7484 42 21.1504 42V42C9.55241 42 0.150391 32.598 0.150391 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredOkBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173973)">
            <path
                d="M0.479492 28C0.479492 12.536 13.0155 0 28.4795 0V0C43.9435 0 56.4795 12.536 56.4795 28V28C56.4795 43.464 43.9435 56 28.4795 56V56C13.0155 56 0.479492 43.464 0.479492 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.4795" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M33.1192 25.92H25.6525H24.8525V16.5866L25.6525 15.7866H33.1192L33.9192 16.5866V25.92H33.1192ZM26.4525 24.32H32.3192V17.3866H26.4525V24.32V24.32Z"
            fill={colors.primary_O}
        />
        <path
            d="M38.3993 28.2133C38.346 28.2133 38.2926 28.2133 38.2393 28.2133V15.7866H20.6393V29.12C20.0526 29.5466 19.5726 30.1333 19.306 30.88L15.626 39.4133L17.1193 40.0533L20.7993 31.52C21.226 30.5066 22.2393 29.8133 23.4126 29.8133H31.6793C31.3593 30.7733 30.4526 31.4133 29.386 31.4133H24.7993V33.0133H29.386H33.8126L34.3993 32.8L36.6926 30.5066C37.4393 29.76 38.5593 29.6 39.466 30.0266L34.826 34.6666C34.1326 35.36 33.226 35.7333 32.266 35.7333H29.1726C26.5593 35.7333 24.1593 37.12 22.7726 39.3066L24.1593 40.16C25.226 38.4 27.146 37.3333 29.1726 37.3333H32.266C33.6526 37.3333 34.9326 36.8 35.946 35.7866L41.2793 30.4533V29.3333C40.4793 28.64 39.466 28.2133 38.3993 28.2133ZM33.4926 31.4133H32.586C33.1193 30.72 33.386 29.92 33.386 29.0133L32.586 28.2133H23.306C22.9326 28.2133 22.5593 28.2666 22.186 28.3733V17.3866H36.586V28.64C36.2126 28.8533 35.8393 29.0666 35.5193 29.3866L33.4926 31.4133Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173973">
                <path
                    d="M0.479492 28C0.479492 12.536 13.0155 0 28.4795 0V0C43.9435 0 56.4795 12.536 56.4795 28V28C56.4795 43.464 43.9435 56 28.4795 56V56C13.0155 56 0.479492 43.464 0.479492 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredOkWithWarningBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173973)">
            <path
                d="M0.479492 28C0.479492 12.536 13.0155 0 28.4795 0V0C43.9435 0 56.4795 12.536 56.4795 28V28C56.4795 43.464 43.9435 56 28.4795 56V56C13.0155 56 0.479492 43.464 0.479492 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.4795" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M33.1192 25.92H25.6525H24.8525V16.5866L25.6525 15.7866H33.1192L33.9192 16.5866V25.92H33.1192ZM26.4525 24.32H32.3192V17.3866H26.4525V24.32V24.32Z"
            fill={colors.primary_O}
        />
        <path
            d="M38.3993 28.2133C38.346 28.2133 38.2926 28.2133 38.2393 28.2133V15.7866H20.6393V29.12C20.0526 29.5466 19.5726 30.1333 19.306 30.88L15.626 39.4133L17.1193 40.0533L20.7993 31.52C21.226 30.5066 22.2393 29.8133 23.4126 29.8133H31.6793C31.3593 30.7733 30.4526 31.4133 29.386 31.4133H24.7993V33.0133H29.386H33.8126L34.3993 32.8L36.6926 30.5066C37.4393 29.76 38.5593 29.6 39.466 30.0266L34.826 34.6666C34.1326 35.36 33.226 35.7333 32.266 35.7333H29.1726C26.5593 35.7333 24.1593 37.12 22.7726 39.3066L24.1593 40.16C25.226 38.4 27.146 37.3333 29.1726 37.3333H32.266C33.6526 37.3333 34.9326 36.8 35.946 35.7866L41.2793 30.4533V29.3333C40.4793 28.64 39.466 28.2133 38.3993 28.2133ZM33.4926 31.4133H32.586C33.1193 30.72 33.386 29.92 33.386 29.0133L32.586 28.2133H23.306C22.9326 28.2133 22.5593 28.2666 22.186 28.3733V17.3866H36.586V28.64C36.2126 28.8533 35.8393 29.0666 35.5193 29.3866L33.4926 31.4133Z"
            fill={colors.icon}
        />
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_173973">
                <path
                    d="M0.479492 28C0.479492 12.536 13.0155 0 28.4795 0V0C43.9435 0 56.4795 12.536 56.4795 28V28C56.4795 43.464 43.9435 56 28.4795 56V56C13.0155 56 0.479492 43.464 0.479492 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredDisabledIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174001)">
            <path
                d="M0.863281 21C0.863281 9.40202 10.2653 0 21.8633 0V0C33.4613 0 42.8633 9.40202 42.8633 21V21C42.8633 32.598 33.4613 42 21.8633 42V42C10.2653 42 0.863281 32.598 0.863281 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.8633" cy="21" r="21" fill="#F8F9FE" />
        </g>
        <path
            d="M25.3436 19.4401H19.7436H19.1436V12.4401L19.7436 11.8401H25.3436L25.9436 12.4401V19.4401H25.3436ZM20.3436 18.2401H24.7436V13.0401H20.3436V18.2401V18.2401Z"
            fill="#7E8CB2"
        />
        <path
            d="M29.3036 21.1601C29.2636 21.1601 29.2236 21.1601 29.1836 21.1601V11.8401H15.9836V21.8401C15.5436 22.1601 15.1836 22.6001 14.9836 23.1601L12.2236 29.5601L13.3436 30.0401L16.1036 23.6401C16.4236 22.8801 17.1836 22.3601 18.0636 22.3601H24.2636C24.0236 23.0801 23.3436 23.5601 22.5436 23.5601H19.1036V24.7601H22.5436H25.8636L26.3036 24.6001L28.0236 22.8801C28.5836 22.3201 29.4236 22.2001 30.1036 22.5201L26.6236 26.0001C26.1036 26.5201 25.4236 26.8001 24.7036 26.8001H22.3836C20.4236 26.8001 18.6236 27.8401 17.5836 29.4801L18.6236 30.1201C19.4236 28.8001 20.8636 28.0001 22.3836 28.0001H24.7036C25.7436 28.0001 26.7036 27.6001 27.4636 26.8401L31.4636 22.8401V22.0001C30.8636 21.4801 30.1036 21.1601 29.3036 21.1601ZM25.6236 23.5601H24.9436C25.3436 23.0401 25.5436 22.4401 25.5436 21.7601L24.9436 21.1601H17.9836C17.7036 21.1601 17.4236 21.2001 17.1436 21.2801V13.0401H27.9436V21.4801C27.6636 21.6401 27.3836 21.8001 27.1436 22.0401L25.6236 23.5601Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_174001">
                <path
                    d="M0.863281 21C0.863281 9.40202 10.2653 0 21.8633 0V0C33.4613 0 42.8633 9.40202 42.8633 21V21C42.8633 32.598 33.4613 42 21.8633 42V42C10.2653 42 0.863281 32.598 0.863281 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredDisabledBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173999)">
            <path
                d="M0.191406 28C0.191406 12.536 12.7274 0 28.1914 0V0C43.6554 0 56.1914 12.536 56.1914 28V28C56.1914 43.464 43.6554 56 28.1914 56V56C12.7274 56 0.191406 43.464 0.191406 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.1914" cy="28" r="28" fill="#F8F9FE" />
        </g>
        <path
            d="M32.8311 25.92H25.3645H24.5645V16.5866L25.3645 15.7866H32.8311L33.6311 16.5866V25.92H32.8311ZM26.1645 24.32H32.0311V17.3866H26.1645V24.32V24.32Z"
            fill="#7E8CB2"
        />
        <path
            d="M38.1112 28.2133C38.0579 28.2133 38.0046 28.2133 37.9512 28.2133V15.7866H20.3512V29.12C19.7646 29.5466 19.2846 30.1333 19.0179 30.88L15.3379 39.4133L16.8312 40.0533L20.5112 31.52C20.9379 30.5066 21.9512 29.8133 23.1246 29.8133H31.3912C31.0712 30.7733 30.1646 31.4133 29.0979 31.4133H24.5112V33.0133H29.0979H33.5246L34.1112 32.8L36.4046 30.5066C37.1512 29.76 38.2712 29.6 39.1779 30.0266L34.5379 34.6666C33.8446 35.36 32.9379 35.7333 31.9779 35.7333H28.8846C26.2712 35.7333 23.8712 37.12 22.4846 39.3066L23.8712 40.16C24.9379 38.4 26.8579 37.3333 28.8846 37.3333H31.9779C33.3646 37.3333 34.6446 36.8 35.6579 35.7866L40.9912 30.4533V29.3333C40.1912 28.64 39.1779 28.2133 38.1112 28.2133ZM33.2046 31.4133H32.2979C32.8312 30.72 33.0979 29.92 33.0979 29.0133L32.2979 28.2133H23.0179C22.6446 28.2133 22.2712 28.2666 21.8979 28.3733V17.3866H36.2979V28.64C35.9246 28.8533 35.5512 29.0666 35.2312 29.3866L33.2046 31.4133Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_173999">
                <path
                    d="M0.191406 28C0.191406 12.536 12.7274 0 28.1914 0V0C43.6554 0 56.1914 12.536 56.1914 28V28C56.1914 43.464 43.6554 56 28.1914 56V56C12.7274 56 0.191406 43.464 0.191406 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredErrorIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174068)">
            <path
                d="M0.287109 22C0.287109 10.402 9.68913 1 21.2871 1V1C32.8851 1 42.2871 10.402 42.2871 22V22C42.2871 33.598 32.8851 43 21.2871 43V43C9.68913 43 0.287109 33.598 0.287109 22V22Z"
                fill="#F9675D"
            />
            <circle cx="21.2871" cy="22" r="20" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M24.7674 20.4401H19.1674H18.5674V13.4401L19.1674 12.8401H24.7674L25.3674 13.4401V20.4401H24.7674ZM19.7674 19.2401H24.1674V14.0401H19.7674V19.2401V19.2401Z"
            fill="#F9675D"
        />
        <path
            d="M28.7275 22.1601C28.6875 22.1601 28.6475 22.1601 28.6075 22.1601V12.8401H15.4075V22.8401C14.9675 23.1601 14.6075 23.6001 14.4075 24.1601L11.6475 30.5601L12.7675 31.0401L15.5275 24.6401C15.8475 23.8801 16.6075 23.3601 17.4875 23.3601H23.6875C23.4475 24.0801 22.7675 24.5601 21.9675 24.5601H18.5275V25.7601H21.9675H25.2875L25.7275 25.6001L27.4475 23.8801C28.0075 23.3201 28.8475 23.2001 29.5275 23.5201L26.0475 27.0001C25.5275 27.5201 24.8475 27.8001 24.1275 27.8001H21.8075C19.8475 27.8001 18.0475 28.8401 17.0075 30.4801L18.0475 31.1201C18.8475 29.8001 20.2875 29.0001 21.8075 29.0001H24.1275C25.1675 29.0001 26.1275 28.6001 26.8875 27.8401L30.8875 23.8401V23.0001C30.2875 22.4801 29.5275 22.1601 28.7275 22.1601ZM25.0475 24.5601H24.3675C24.7675 24.0401 24.9675 23.4401 24.9675 22.7601L24.3675 22.1601H17.4075C17.1275 22.1601 16.8475 22.2001 16.5675 22.2801V14.0401H27.3675V22.4801C27.0875 22.6401 26.8075 22.8001 26.5675 23.0401L25.0475 24.5601Z"
            fill="#F9675D"
        />
        <circle cx="33.2871" cy="9" r="9" fill="#F9675D" />
        <path
            d="M33.6796 2.23193H32.9516L27.3516 13.4319L27.7436 14.0479H38.9436L39.3356 13.4319L33.6796 2.23193ZM28.3596 13.2079L33.2876 3.35193L38.2156 13.2079H28.3596Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M33.7355 6.26392H32.8955V10.1839H33.7355V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M33.7912 11.136H32.7832V12.144H33.7912V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174068">
                <path
                    d="M0.287109 22C0.287109 10.402 9.68913 1 21.2871 1V1C32.8851 1 42.2871 10.402 42.2871 22V22C42.2871 33.598 32.8851 43 21.2871 43V43C9.68913 43 0.287109 33.598 0.287109 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredErrorBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174065)">
            <path
                d="M0.616211 29C0.616211 13.536 13.1522 1 28.6162 1V1C44.0802 1 56.6162 13.536 56.6162 29V29C56.6162 44.464 44.0802 57 28.6162 57V57C13.1522 57 0.616211 44.464 0.616211 29V29Z"
                fill="#F9675D"
            />
            <circle cx="28.6162" cy="29" r="27" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M33.2559 26.92H25.7893H24.9893V17.5866L25.7893 16.7866H33.2559L34.0559 17.5866V26.92H33.2559ZM26.5893 25.32H32.4559V18.3866H26.5893V25.32V25.32Z"
            fill="#F9675D"
        />
        <path
            d="M38.536 29.2133C38.4827 29.2133 38.4294 29.2133 38.376 29.2133V16.7866H20.776V30.12C20.1894 30.5466 19.7094 31.1333 19.4427 31.88L15.7627 40.4133L17.256 41.0533L20.936 32.52C21.3627 31.5066 22.376 30.8133 23.5494 30.8133H31.816C31.496 31.7733 30.5894 32.4133 29.5227 32.4133H24.936V34.0133H29.5227H33.9494L34.536 33.8L36.8294 31.5066C37.576 30.76 38.696 30.6 39.6027 31.0266L34.9627 35.6666C34.2694 36.36 33.3627 36.7333 32.4027 36.7333H29.3094C26.696 36.7333 24.296 38.12 22.9094 40.3066L24.296 41.16C25.3627 39.4 27.2827 38.3333 29.3094 38.3333H32.4027C33.7894 38.3333 35.0694 37.8 36.0827 36.7866L41.416 31.4533V30.3333C40.616 29.64 39.6027 29.2133 38.536 29.2133ZM33.6294 32.4133H32.7227C33.256 31.72 33.5227 30.92 33.5227 30.0133L32.7227 29.2133H23.4427C23.0694 29.2133 22.696 29.2666 22.3227 29.3733V18.3866H36.7227V29.64C36.3494 29.8533 35.976 30.0666 35.656 30.3866L33.6294 32.4133Z"
            fill="#F9675D"
        />
        <circle cx="47.6162" cy="9" r="9" fill="#F9675D" />
        <path
            d="M48.0087 2.23193H47.2807L41.6807 13.4319L42.0727 14.0479H53.2727L53.6647 13.4319L48.0087 2.23193ZM42.6887 13.2079L47.6167 3.35193L52.5447 13.2079H42.6887Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M48.0646 6.26392H47.2246V10.1839H48.0646V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M48.1203 11.136H47.1123V12.144H48.1203V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174065">
                <path
                    d="M0.616211 29C0.616211 13.536 13.1522 1 28.6162 1V1C44.0802 1 56.6162 13.536 56.6162 29V29C56.6162 44.464 44.0802 57 28.6162 57V57C13.1522 57 0.616211 44.464 0.616211 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredWarningIcon = () => (
    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174102)">
            <path
                d="M-0.000976562 22C-0.000976562 10.402 9.40104 1 20.999 1V1C32.597 1 41.999 10.402 41.999 22V22C41.999 33.598 32.597 43 20.999 43V43C9.40104 43 -0.000976562 33.598 -0.000976562 22V22Z"
                fill="#ED9937"
            />
            <circle cx="20.999" cy="22" r="20" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M24.4793 20.4401H18.8793H18.2793V13.4401L18.8793 12.8401H24.4793L25.0793 13.4401V20.4401H24.4793ZM19.4793 19.2401H23.8793V14.0401H19.4793V19.2401V19.2401Z"
            fill="#ED9937"
        />
        <path
            d="M28.4394 22.1601C28.3994 22.1601 28.3594 22.1601 28.3194 22.1601V12.8401H15.1194V22.8401C14.6794 23.1601 14.3194 23.6001 14.1194 24.1601L11.3594 30.5601L12.4794 31.0401L15.2394 24.6401C15.5594 23.8801 16.3194 23.3601 17.1994 23.3601H23.3994C23.1594 24.0801 22.4794 24.5601 21.6794 24.5601H18.2394V25.7601H21.6794H24.9994L25.4394 25.6001L27.1594 23.8801C27.7194 23.3201 28.5594 23.2001 29.2394 23.5201L25.7594 27.0001C25.2394 27.5201 24.5594 27.8001 23.8394 27.8001H21.5194C19.5594 27.8001 17.7594 28.8401 16.7194 30.4801L17.7594 31.1201C18.5594 29.8001 19.9994 29.0001 21.5194 29.0001H23.8394C24.8794 29.0001 25.8394 28.6001 26.5994 27.8401L30.5994 23.8401V23.0001C29.9994 22.4801 29.2394 22.1601 28.4394 22.1601ZM24.7594 24.5601H24.0794C24.4794 24.0401 24.6794 23.4401 24.6794 22.7601L24.0794 22.1601H17.1194C16.8394 22.1601 16.5594 22.2001 16.2794 22.2801V14.0401H27.0794V22.4801C26.7994 22.6401 26.5194 22.8001 26.2794 23.0401L24.7594 24.5601Z"
            fill="#ED9937"
        />
        <circle cx="35.249" cy="7" r="6.75" fill="#FFB865" />
        <path
            d="M37.6427 5.87203C37.6427 4.52804 36.5507 3.43604 35.2067 3.43604C33.8627 3.43604 32.7707 4.52804 32.7707 5.87203V7.63603H31.7627V10.576H38.6927V7.63603H37.6427V5.87203ZM33.4427 5.87203C33.4427 4.90604 34.2407 4.10804 35.2067 4.10804C36.1727 4.10804 36.9707 4.90604 36.9707 5.87203V7.63603H33.4427V5.87203ZM38.0627 8.30803V9.98803H32.4347V8.30803H32.8547H37.6847H38.0627Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M35.5851 1.88208H34.9551V2.93208H35.5851V1.88208Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M39.4484 5.78809H38.3984V6.41809H39.4484V5.78809Z" fill="#623602" />
        <path d="M32.0988 5.78809H31.0488V6.41809H32.0988V5.78809Z" fill="#623602" />
        <path d="M38.1985 2.72214L37.4561 3.4646L37.9015 3.91007L38.644 3.16762L38.1985 2.72214Z" fill="#623602" />
        <path d="M32.3234 2.74203L31.8779 3.1875L32.6204 3.92996L33.0659 3.48448L32.3234 2.74203Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174102">
                <path
                    d="M-0.000976562 22C-0.000976562 10.402 9.40104 1 20.999 1V1C32.597 1 41.999 10.402 41.999 22V22C41.999 33.598 32.597 43 20.999 43V43C9.40104 43 -0.000976562 33.598 -0.000976562 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174099)">
            <path
                d="M0.328125 29C0.328125 13.536 12.8642 1 28.3281 1V1C43.7921 1 56.3281 13.536 56.3281 29V29C56.3281 44.464 43.7921 57 28.3281 57V57C12.8642 57 0.328125 44.464 0.328125 29V29Z"
                fill="#ED9937"
            />
            <circle cx="28.3281" cy="29" r="27" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M32.9678 26.92H25.5012H24.7012V17.5866L25.5012 16.7866H32.9678L33.7678 17.5866V26.92H32.9678ZM26.3012 25.32H32.1678V18.3866H26.3012V25.32V25.32Z"
            fill="#ED9937"
        />
        <path
            d="M38.2479 29.2133C38.1946 29.2133 38.1413 29.2133 38.0879 29.2133V16.7866H20.4879V30.12C19.9013 30.5466 19.4213 31.1333 19.1546 31.88L15.4746 40.4133L16.9679 41.0533L20.6479 32.52C21.0746 31.5066 22.0879 30.8133 23.2613 30.8133H31.5279C31.2079 31.7733 30.3013 32.4133 29.2346 32.4133H24.6479V34.0133H29.2346H33.6613L34.2479 33.8L36.5413 31.5066C37.2879 30.76 38.4079 30.6 39.3146 31.0266L34.6746 35.6666C33.9813 36.36 33.0746 36.7333 32.1146 36.7333H29.0213C26.4079 36.7333 24.0079 38.12 22.6213 40.3066L24.0079 41.16C25.0746 39.4 26.9946 38.3333 29.0213 38.3333H32.1146C33.5013 38.3333 34.7813 37.8 35.7946 36.7866L41.1279 31.4533V30.3333C40.3279 29.64 39.3146 29.2133 38.2479 29.2133ZM33.3413 32.4133H32.4346C32.9679 31.72 33.2346 30.92 33.2346 30.0133L32.4346 29.2133H23.1546C22.7813 29.2133 22.4079 29.2666 22.0346 29.3733V18.3866H36.4346V29.64C36.0613 29.8533 35.6879 30.0666 35.3679 30.3866L33.3413 32.4133Z"
            fill="#ED9937"
        />
        <circle cx="47.3281" cy="9" r="9" fill="#FFB865" />
        <path
            d="M50.5207 7.49605C50.5207 5.70405 49.0647 4.24805 47.2727 4.24805C45.4807 4.24805 44.0247 5.70405 44.0247 7.49605V9.84805H42.6807V13.768H51.9207V9.84805H50.5207V7.49605ZM44.9207 7.49605C44.9207 6.20805 45.9847 5.14405 47.2727 5.14405C48.5607 5.14405 49.6247 6.20805 49.6247 7.49605V9.84805H44.9207V7.49605ZM51.0807 10.744V12.984H43.5767V10.744H44.1367H50.5767H51.0807Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M47.7765 2.17603H46.9365V3.57603H47.7765V2.17603Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M52.9283 7.38403H51.5283V8.22403H52.9283V7.38403Z" fill="#623602" />
        <path d="M43.1285 7.38403H41.7285V8.22403H43.1285V7.38403Z" fill="#623602" />
        <path d="M51.2614 3.29595L50.2715 4.28589L50.8654 4.87985L51.8554 3.88991L51.2614 3.29595Z" fill="#623602" />
        <path d="M43.4279 3.32278L42.834 3.91675L43.8239 4.90669L44.4179 4.31272L43.4279 3.32278Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174099">
                <path
                    d="M0.328125 29C0.328125 13.536 12.8642 1 28.3281 1V1C43.7921 1 56.3281 13.536 56.3281 29V29C56.3281 44.464 43.7921 57 28.3281 57V57C12.8642 57 0.328125 44.464 0.328125 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredSuccessIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174034)">
            <path
                d="M0.576172 22C0.576172 10.402 9.97819 1 21.5762 1V1C33.1742 1 42.5762 10.402 42.5762 22V22C42.5762 33.598 33.1742 43 21.5762 43V43C9.97819 43 0.576172 33.598 0.576172 22V22Z"
                fill="#93E191"
            />
            <circle cx="21.5762" cy="22" r="20" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M25.0564 20.4401H19.4564H18.8564V13.4401L19.4564 12.8401H25.0564L25.6564 13.4401V20.4401H25.0564ZM20.0564 19.2401H24.4564V14.0401H20.0564V19.2401V19.2401Z"
            fill="#54C65F"
        />
        <path
            d="M29.0165 22.1601C28.9765 22.1601 28.9365 22.1601 28.8965 22.1601V12.8401H15.6965V22.8401C15.2565 23.1601 14.8965 23.6001 14.6965 24.1601L11.9365 30.5601L13.0565 31.0401L15.8165 24.6401C16.1365 23.8801 16.8965 23.3601 17.7765 23.3601H23.9765C23.7365 24.0801 23.0565 24.5601 22.2565 24.5601H18.8165V25.7601H22.2565H25.5765L26.0165 25.6001L27.7365 23.8801C28.2965 23.3201 29.1365 23.2001 29.8165 23.5201L26.3365 27.0001C25.8165 27.5201 25.1365 27.8001 24.4165 27.8001H22.0965C20.1365 27.8001 18.3365 28.8401 17.2965 30.4801L18.3365 31.1201C19.1365 29.8001 20.5765 29.0001 22.0965 29.0001H24.4165C25.4565 29.0001 26.4165 28.6001 27.1765 27.8401L31.1765 23.8401V23.0001C30.5765 22.4801 29.8165 22.1601 29.0165 22.1601ZM25.3365 24.5601H24.6565C25.0565 24.0401 25.2565 23.4401 25.2565 22.7601L24.6565 22.1601H17.6965C17.4165 22.1601 17.1365 22.2001 16.8565 22.2801V14.0401H27.6565V22.4801C27.3765 22.6401 27.0965 22.8001 26.8565 23.0401L25.3365 24.5601Z"
            fill="#54C65F"
        />
        <circle cx="35.8262" cy="7" r="6.75" fill="#54C65F" />
        <path
            d="M38.7964 4.30005L34.4764 8.56605L32.8564 6.94605L32.3164 7.54005L34.4764 9.70005L39.3364 4.84005L38.7964 4.30005Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174034">
                <path
                    d="M0.576172 22C0.576172 10.402 9.97819 1 21.5762 1V1C33.1742 1 42.5762 10.402 42.5762 22V22C42.5762 33.598 33.1742 43 21.5762 43V43C9.97819 43 0.576172 33.598 0.576172 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredSuccessBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174031)">
            <path
                d="M0.904297 29C0.904297 13.536 13.4403 1 28.9043 1V1C44.3683 1 56.9043 13.536 56.9043 29V29C56.9043 44.464 44.3683 57 28.9043 57V57C13.4403 57 0.904297 44.464 0.904297 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.9043" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M33.544 26.92H26.0773H25.2773V17.5866L26.0773 16.7866H33.544L34.344 17.5866V26.92H33.544ZM26.8773 25.32H32.744V18.3866H26.8773V25.32V25.32Z"
            fill="#54C65F"
        />
        <path
            d="M38.8241 29.2133C38.7708 29.2133 38.7174 29.2133 38.6641 29.2133V16.7866H21.0641V30.12C20.4774 30.5466 19.9974 31.1333 19.7308 31.88L16.0508 40.4133L17.5441 41.0533L21.2241 32.52C21.6508 31.5066 22.6641 30.8133 23.8374 30.8133H32.1041C31.7841 31.7733 30.8774 32.4133 29.8108 32.4133H25.2241V34.0133H29.8108H34.2374L34.8241 33.8L37.1174 31.5066C37.8641 30.76 38.9841 30.6 39.8908 31.0266L35.2508 35.6666C34.5574 36.36 33.6508 36.7333 32.6908 36.7333H29.5974C26.9841 36.7333 24.5841 38.12 23.1974 40.3066L24.5841 41.16C25.6508 39.4 27.5708 38.3333 29.5974 38.3333H32.6908C34.0774 38.3333 35.3574 37.8 36.3708 36.7866L41.7041 31.4533V30.3333C40.9041 29.64 39.8908 29.2133 38.8241 29.2133ZM33.9174 32.4133H33.0108C33.5441 31.72 33.8108 30.92 33.8108 30.0133L33.0108 29.2133H23.7308C23.3574 29.2133 22.9841 29.2666 22.6108 29.3733V18.3866H37.0108V29.64C36.6374 29.8533 36.2641 30.0666 35.9441 30.3866L33.9174 32.4133Z"
            fill="#54C65F"
        />
        <circle cx="47.9043" cy="9" r="9" fill="#54C65F" />
        <path
            d="M51.8646 5.3999L46.1046 11.0879L43.9446 8.9279L43.2246 9.7199L46.1046 12.5999L52.5846 6.1199L51.8646 5.3999Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174031">
                <path
                    d="M0.904297 29C0.904297 13.536 13.4403 1 28.9043 1V1C44.3683 1 56.9043 13.536 56.9043 29V29C56.9043 44.464 44.3683 57 28.9043 57V57C13.4403 57 0.904297 44.464 0.904297 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const DeliveredSuccessWithWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174031)">
            <path
                d="M0.904297 29C0.904297 13.536 13.4403 1 28.9043 1V1C44.3683 1 56.9043 13.536 56.9043 29V29C56.9043 44.464 44.3683 57 28.9043 57V57C13.4403 57 0.904297 44.464 0.904297 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.9043" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M33.544 26.92H26.0773H25.2773V17.5866L26.0773 16.7866H33.544L34.344 17.5866V26.92H33.544ZM26.8773 25.32H32.744V18.3866H26.8773V25.32V25.32Z"
            fill="#54C65F"
        />
        <path
            d="M38.8241 29.2133C38.7708 29.2133 38.7174 29.2133 38.6641 29.2133V16.7866H21.0641V30.12C20.4774 30.5466 19.9974 31.1333 19.7308 31.88L16.0508 40.4133L17.5441 41.0533L21.2241 32.52C21.6508 31.5066 22.6641 30.8133 23.8374 30.8133H32.1041C31.7841 31.7733 30.8774 32.4133 29.8108 32.4133H25.2241V34.0133H29.8108H34.2374L34.8241 33.8L37.1174 31.5066C37.8641 30.76 38.9841 30.6 39.8908 31.0266L35.2508 35.6666C34.5574 36.36 33.6508 36.7333 32.6908 36.7333H29.5974C26.9841 36.7333 24.5841 38.12 23.1974 40.3066L24.5841 41.16C25.6508 39.4 27.5708 38.3333 29.5974 38.3333H32.6908C34.0774 38.3333 35.3574 37.8 36.3708 36.7866L41.7041 31.4533V30.3333C40.9041 29.64 39.8908 29.2133 38.8241 29.2133ZM33.9174 32.4133H33.0108C33.5441 31.72 33.8108 30.92 33.8108 30.0133L33.0108 29.2133H23.7308C23.3574 29.2133 22.9841 29.2666 22.6108 29.3733V18.3866H37.0108V29.64C36.6374 29.8533 36.2641 30.0666 35.9441 30.3866L33.9174 32.4133Z"
            fill="#54C65F"
        />
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_174031">
                <path
                    d="M0.904297 29C0.904297 13.536 13.4403 1 28.9043 1V1C44.3683 1 56.9043 13.536 56.9043 29V29C56.9043 44.464 44.3683 57 28.9043 57V57C13.4403 57 0.904297 44.464 0.904297 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayOkIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173971)">
            <path
                d="M0.807617 21C0.807617 9.40202 10.2096 0 21.8076 0V0C33.4056 0 42.8076 9.40202 42.8076 21V21C42.8076 32.598 33.4056 42 21.8076 42V42C10.2096 42 0.807617 32.598 0.807617 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.8076" cy="21" r="20" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M30.3274 20.5199L27.8474 19.9999L26.6874 14.9199L26.6074 14.4399H11.6074V15.0399V27.2799V27.8799H14.9674V26.6799H12.8074V15.6399H21.2074V26.6799H19.2074V27.8799H24.4474V26.6799H22.4474V21.0799H27.3274L29.8874 21.5999C30.4474 21.9199 30.8074 22.5999 30.8074 23.3199V26.6399H28.6474V27.8399H32.0074V27.2399V23.3999C32.0074 22.1199 31.3674 20.9999 30.3274 20.5199ZM22.4074 19.9199V15.6399H25.6474L26.6074 19.9199H22.4074Z"
            fill={colors.icon}
        />
        <path
            d="M17.0872 30.0001C15.6072 30.0001 14.3672 28.8001 14.3672 27.2801C14.3672 25.7601 15.5672 24.5601 17.0872 24.5601C18.6072 24.5601 19.8072 25.7601 19.8072 27.2801C19.8072 28.8001 18.5672 30.0001 17.0872 30.0001ZM17.0872 25.8001C16.2472 25.8001 15.5672 26.4801 15.5672 27.3201C15.5672 28.1601 16.2472 28.8401 17.0872 28.8401C17.9272 28.8401 18.6072 28.1601 18.6072 27.3201C18.6072 26.4801 17.9272 25.8001 17.0872 25.8001Z"
            fill={colors.primary_O}
        />
        <path
            d="M26.5276 30.0001C25.0476 30.0001 23.8076 28.8001 23.8076 27.2801C23.8076 25.7601 25.0076 24.5601 26.5276 24.5601C28.0476 24.5601 29.2476 25.7601 29.2476 27.2801C29.2476 28.8001 28.0076 30.0001 26.5276 30.0001ZM26.5276 25.8001C25.6876 25.8001 25.0076 26.4801 25.0076 27.3201C25.0076 28.1601 25.6876 28.8401 26.5276 28.8401C27.3676 28.8401 28.0476 28.1601 28.0476 27.3201C28.0476 26.4801 27.3676 25.8001 26.5276 25.8001Z"
            fill={colors.primary_O}
        />
        <defs>
            <clipPath id="clip0_13649_173971">
                <path
                    d="M0.807617 21C0.807617 9.40202 10.2096 0 21.8076 0V0C33.4056 0 42.8076 9.40202 42.8076 21V21C42.8076 32.598 33.4056 42 21.8076 42V42C10.2096 42 0.807617 32.598 0.807617 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayOkBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173969)">
            <path
                d="M0.136719 28C0.136719 12.536 12.6727 0 28.1367 0V0C43.6007 0 56.1367 12.536 56.1367 28V28C56.1367 43.464 43.6007 56 28.1367 56V56C12.6727 56 0.136719 43.464 0.136719 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.1367" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M39.4971 27.3601L36.1904 26.6668L34.6438 19.8934L34.5371 19.2534H14.5371V20.0534V36.3734V37.1734H19.0171V35.5734H16.1371V20.8534H27.3371V35.5734H24.6704V37.1734H31.6571V35.5734H28.9904V28.1068H35.4971L38.9104 28.8001C39.6571 29.2268 40.1371 30.1334 40.1371 31.0934V35.5201H37.2571V37.1201H41.7371V36.3201V31.2001C41.7371 29.4934 40.8838 28.0001 39.4971 27.3601ZM28.9371 26.5601V20.8534H33.2571L34.5371 26.5601H28.9371Z"
            fill={colors.icon}
        />
        <path
            d="M21.8435 40.0002C19.8701 40.0002 18.2168 38.4002 18.2168 36.3735C18.2168 34.3468 19.8168 32.7468 21.8435 32.7468C23.8701 32.7468 25.4701 34.3468 25.4701 36.3735C25.4701 38.4002 23.8168 40.0002 21.8435 40.0002ZM21.8435 34.4002C20.7235 34.4002 19.8168 35.3068 19.8168 36.4268C19.8168 37.5468 20.7235 38.4535 21.8435 38.4535C22.9635 38.4535 23.8701 37.5468 23.8701 36.4268C23.8701 35.3068 22.9635 34.4002 21.8435 34.4002Z"
            fill={colors.primary_O}
        />
        <path
            d="M34.4304 40.0002C32.457 40.0002 30.8037 38.4002 30.8037 36.3735C30.8037 34.3468 32.4037 32.7468 34.4304 32.7468C36.457 32.7468 38.057 34.3468 38.057 36.3735C38.057 38.4002 36.4037 40.0002 34.4304 40.0002ZM34.4304 34.4002C33.3104 34.4002 32.4037 35.3068 32.4037 36.4268C32.4037 37.5468 33.3104 38.4535 34.4304 38.4535C35.5504 38.4535 36.457 37.5468 36.457 36.4268C36.457 35.3068 35.5504 34.4002 34.4304 34.4002Z"
            fill={colors.primary_O}
        />
        <defs>
            <clipPath id="clip0_13649_173969">
                <path
                    d="M0.136719 28C0.136719 12.536 12.6727 0 28.1367 0V0C43.6007 0 56.1367 12.536 56.1367 28V28C56.1367 43.464 43.6007 56 28.1367 56V56C12.6727 56 0.136719 43.464 0.136719 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayOkWithWarningBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173969)">
            <path
                d="M0.136719 28C0.136719 12.536 12.6727 0 28.1367 0V0C43.6007 0 56.1367 12.536 56.1367 28V28C56.1367 43.464 43.6007 56 28.1367 56V56C12.6727 56 0.136719 43.464 0.136719 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.1367" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M39.4971 27.3601L36.1904 26.6668L34.6438 19.8934L34.5371 19.2534H14.5371V20.0534V36.3734V37.1734H19.0171V35.5734H16.1371V20.8534H27.3371V35.5734H24.6704V37.1734H31.6571V35.5734H28.9904V28.1068H35.4971L38.9104 28.8001C39.6571 29.2268 40.1371 30.1334 40.1371 31.0934V35.5201H37.2571V37.1201H41.7371V36.3201V31.2001C41.7371 29.4934 40.8838 28.0001 39.4971 27.3601ZM28.9371 26.5601V20.8534H33.2571L34.5371 26.5601H28.9371Z"
            fill={colors.icon}
        />
        <path
            d="M21.8435 40.0002C19.8701 40.0002 18.2168 38.4002 18.2168 36.3735C18.2168 34.3468 19.8168 32.7468 21.8435 32.7468C23.8701 32.7468 25.4701 34.3468 25.4701 36.3735C25.4701 38.4002 23.8168 40.0002 21.8435 40.0002ZM21.8435 34.4002C20.7235 34.4002 19.8168 35.3068 19.8168 36.4268C19.8168 37.5468 20.7235 38.4535 21.8435 38.4535C22.9635 38.4535 23.8701 37.5468 23.8701 36.4268C23.8701 35.3068 22.9635 34.4002 21.8435 34.4002Z"
            fill={colors.primary_O}
        />
        <path
            d="M34.4304 40.0002C32.457 40.0002 30.8037 38.4002 30.8037 36.3735C30.8037 34.3468 32.4037 32.7468 34.4304 32.7468C36.457 32.7468 38.057 34.3468 38.057 36.3735C38.057 38.4002 36.4037 40.0002 34.4304 40.0002ZM34.4304 34.4002C33.3104 34.4002 32.4037 35.3068 32.4037 36.4268C32.4037 37.5468 33.3104 38.4535 34.4304 38.4535C35.5504 38.4535 36.457 37.5468 36.457 36.4268C36.457 35.3068 35.5504 34.4002 34.4304 34.4002Z"
            fill={colors.primary_O}
        />
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_173969">
                <path
                    d="M0.136719 28C0.136719 12.536 12.6727 0 28.1367 0V0C43.6007 0 56.1367 12.536 56.1367 28V28C56.1367 43.464 43.6007 56 28.1367 56V56C12.6727 56 0.136719 43.464 0.136719 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayDisabledIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173997)">
            <path
                d="M0.520508 21C0.520508 9.40202 9.92253 0 21.5205 0V0C33.1185 0 42.5205 9.40202 42.5205 21V21C42.5205 32.598 33.1185 42 21.5205 42V42C9.92253 42 0.520508 32.598 0.520508 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.5205" cy="21" r="21" fill="#F8F9FE" />
        </g>
        <path
            d="M30.0403 20.5199L27.5603 19.9999L26.4003 14.9199L26.3203 14.4399H11.3203V15.0399V27.2799V27.8799H14.6803V26.6799H12.5203V15.6399H20.9203V26.6799H18.9203V27.8799H24.1603V26.6799H22.1603V21.0799H27.0403L29.6003 21.5999C30.1603 21.9199 30.5203 22.5999 30.5203 23.3199V26.6399H28.3603V27.8399H31.7203V27.2399V23.3999C31.7203 22.1199 31.0803 20.9999 30.0403 20.5199ZM22.1203 19.9199V15.6399H25.3603L26.3203 19.9199H22.1203Z"
            fill="#7E8CB2"
        />
        <path
            d="M16.8001 30.0001C15.3201 30.0001 14.0801 28.8001 14.0801 27.2801C14.0801 25.7601 15.2801 24.5601 16.8001 24.5601C18.3201 24.5601 19.5201 25.7601 19.5201 27.2801C19.5201 28.8001 18.2801 30.0001 16.8001 30.0001ZM16.8001 25.8001C15.9601 25.8001 15.2801 26.4801 15.2801 27.3201C15.2801 28.1601 15.9601 28.8401 16.8001 28.8401C17.6401 28.8401 18.3201 28.1601 18.3201 27.3201C18.3201 26.4801 17.6401 25.8001 16.8001 25.8001Z"
            fill="#7E8CB2"
        />
        <path
            d="M26.2405 30.0001C24.7605 30.0001 23.5205 28.8001 23.5205 27.2801C23.5205 25.7601 24.7205 24.5601 26.2405 24.5601C27.7605 24.5601 28.9605 25.7601 28.9605 27.2801C28.9605 28.8001 27.7205 30.0001 26.2405 30.0001ZM26.2405 25.8001C25.4005 25.8001 24.7205 26.4801 24.7205 27.3201C24.7205 28.1601 25.4005 28.8401 26.2405 28.8401C27.0805 28.8401 27.7605 28.1601 27.7605 27.3201C27.7605 26.4801 27.0805 25.8001 26.2405 25.8001Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_173997">
                <path
                    d="M0.520508 21C0.520508 9.40202 9.92253 0 21.5205 0V0C33.1185 0 42.5205 9.40202 42.5205 21V21C42.5205 32.598 33.1185 42 21.5205 42V42C9.92253 42 0.520508 32.598 0.520508 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayDisabledBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173995)">
            <path
                d="M0.849609 28C0.849609 12.536 13.3856 0 28.8496 0V0C44.3136 0 56.8496 12.536 56.8496 28V28C56.8496 43.464 44.3136 56 28.8496 56V56C13.3856 56 0.849609 43.464 0.849609 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.8496" cy="28" r="28" fill="#F8F9FE" />
        </g>
        <path
            d="M40.21 27.3601L36.9033 26.6668L35.3567 19.8934L35.25 19.2534H15.25V20.0534V36.3734V37.1734H19.73V35.5734H16.85V20.8534H28.05V35.5734H25.3833V37.1734H32.37V35.5734H29.7033V28.1068H36.21L39.6233 28.8001C40.37 29.2268 40.85 30.1334 40.85 31.0934V35.5201H37.97V37.1201H42.45V36.3201V31.2001C42.45 29.4934 41.5967 28.0001 40.21 27.3601ZM29.65 26.5601V20.8534H33.97L35.25 26.5601H29.65Z"
            fill="#7E8CB2"
        />
        <path
            d="M22.5564 40.0002C20.583 40.0002 18.9297 38.4002 18.9297 36.3735C18.9297 34.3468 20.5297 32.7468 22.5564 32.7468C24.583 32.7468 26.183 34.3468 26.183 36.3735C26.183 38.4002 24.5297 40.0002 22.5564 40.0002ZM22.5564 34.4002C21.4364 34.4002 20.5297 35.3068 20.5297 36.4268C20.5297 37.5468 21.4364 38.4535 22.5564 38.4535C23.6764 38.4535 24.583 37.5468 24.583 36.4268C24.583 35.3068 23.6764 34.4002 22.5564 34.4002Z"
            fill="#7E8CB2"
        />
        <path
            d="M35.1433 40.0002C33.1699 40.0002 31.5166 38.4002 31.5166 36.3735C31.5166 34.3468 33.1166 32.7468 35.1433 32.7468C37.1699 32.7468 38.7699 34.3468 38.7699 36.3735C38.7699 38.4002 37.1166 40.0002 35.1433 40.0002ZM35.1433 34.4002C34.0233 34.4002 33.1166 35.3068 33.1166 36.4268C33.1166 37.5468 34.0233 38.4535 35.1433 38.4535C36.2633 38.4535 37.1699 37.5468 37.1699 36.4268C37.1699 35.3068 36.2633 34.4002 35.1433 34.4002Z"
            fill="#7E8CB2"
        />
        <defs>
            <clipPath id="clip0_13649_173995">
                <path
                    d="M0.849609 28C0.849609 12.536 13.3856 0 28.8496 0V0C44.3136 0 56.8496 12.536 56.8496 28V28C56.8496 43.464 44.3136 56 28.8496 56V56C13.3856 56 0.849609 43.464 0.849609 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayErrorIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174062)">
            <path
                d="M0.945312 22C0.945312 10.402 10.3473 1 21.9453 1V1C33.5433 1 42.9453 10.402 42.9453 22V22C42.9453 33.598 33.5433 43 21.9453 43V43C10.3473 43 0.945312 33.598 0.945312 22V22Z"
                fill="#F9675D"
            />
            <circle cx="21.9453" cy="22" r="20" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M30.4651 21.5199L27.9851 20.9999L26.8251 15.9199L26.7451 15.4399H11.7451V16.0399V28.2799V28.8799H15.1051V27.6799H12.9451V16.6399H21.3451V27.6799H19.3451V28.8799H24.5851V27.6799H22.5851V22.0799H27.4651L30.0251 22.5999C30.5851 22.9199 30.9451 23.5999 30.9451 24.3199V27.6399H28.7851V28.8399H32.1451V28.2399V24.3999C32.1451 23.1199 31.5051 21.9999 30.4651 21.5199ZM22.5451 20.9199V16.6399H25.7851L26.7451 20.9199H22.5451Z"
            fill="#F9675D"
        />
        <path
            d="M17.2249 31.0001C15.7449 31.0001 14.5049 29.8001 14.5049 28.2801C14.5049 26.7601 15.7049 25.5601 17.2249 25.5601C18.7449 25.5601 19.9449 26.7601 19.9449 28.2801C19.9449 29.8001 18.7049 31.0001 17.2249 31.0001ZM17.2249 26.8001C16.3849 26.8001 15.7049 27.4801 15.7049 28.3201C15.7049 29.1601 16.3849 29.8401 17.2249 29.8401C18.0649 29.8401 18.7449 29.1601 18.7449 28.3201C18.7449 27.4801 18.0649 26.8001 17.2249 26.8001Z"
            fill="#F9675D"
        />
        <path
            d="M26.6653 31.0001C25.1853 31.0001 23.9453 29.8001 23.9453 28.2801C23.9453 26.7601 25.1453 25.5601 26.6653 25.5601C28.1853 25.5601 29.3853 26.7601 29.3853 28.2801C29.3853 29.8001 28.1453 31.0001 26.6653 31.0001ZM26.6653 26.8001C25.8253 26.8001 25.1453 27.4801 25.1453 28.3201C25.1453 29.1601 25.8253 29.8401 26.6653 29.8401C27.5053 29.8401 28.1853 29.1601 28.1853 28.3201C28.1853 27.4801 27.5053 26.8001 26.6653 26.8001Z"
            fill="#F9675D"
        />
        <circle cx="33.9453" cy="9" r="9" fill="#F9675D" />
        <g clipPath="url(#clip1_13649_174062)">
            <path
                d="M34.3378 2.23193H33.6098L28.0098 13.4319L28.4018 14.0479H39.6018L39.9938 13.4319L34.3378 2.23193ZM29.0178 13.2079L33.9458 3.35193L38.8738 13.2079H29.0178Z"
                fill="white"
                stroke="white"
                strokeWidth="0.2"
            />
            <path d="M34.3937 6.26392H33.5537V10.1839H34.3937V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
            <path d="M34.4494 11.136H33.4414V12.144H34.4494V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        </g>
        <defs>
            <clipPath id="clip0_13649_174062">
                <path
                    d="M0.945312 22C0.945312 10.402 10.3473 1 21.9453 1V1C33.5433 1 42.9453 10.402 42.9453 22V22C42.9453 33.598 33.5433 43 21.9453 43V43C10.3473 43 0.945312 33.598 0.945312 22V22Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174062">
                <rect width="14" height="14" fill="white" transform="translate(26.9453 1)" />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayErrorBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174059)">
            <path
                d="M0.274414 29C0.274414 13.536 12.8104 1 28.2744 1V1C43.7384 1 56.2744 13.536 56.2744 29V29C56.2744 44.464 43.7384 57 28.2744 57V57C12.8104 57 0.274414 44.464 0.274414 29V29Z"
                fill="#F9675D"
            />
            <circle cx="28.2744" cy="29" r="27" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M39.6348 28.3601L36.3281 27.6668L34.7815 20.8934L34.6748 20.2534H14.6748V21.0534V37.3734V38.1734H19.1548V36.5734H16.2748V21.8534H27.4748V36.5734H24.8081V38.1734H31.7948V36.5734H29.1281V29.1068H35.6348L39.0481 29.8001C39.7948 30.2268 40.2748 31.1334 40.2748 32.0934V36.5201H37.3948V38.1201H41.8748V37.3201V32.2001C41.8748 30.4934 41.0215 29.0001 39.6348 28.3601ZM29.0748 27.5601V21.8534H33.3948L34.6748 27.5601H29.0748Z"
            fill="#F9675D"
        />
        <path
            d="M21.9812 41.0002C20.0078 41.0002 18.3545 39.4002 18.3545 37.3735C18.3545 35.3468 19.9545 33.7468 21.9812 33.7468C24.0078 33.7468 25.6078 35.3468 25.6078 37.3735C25.6078 39.4002 23.9545 41.0002 21.9812 41.0002ZM21.9812 35.4002C20.8612 35.4002 19.9545 36.3068 19.9545 37.4268C19.9545 38.5468 20.8612 39.4535 21.9812 39.4535C23.1012 39.4535 24.0078 38.5468 24.0078 37.4268C24.0078 36.3068 23.1012 35.4002 21.9812 35.4002Z"
            fill="#F9675D"
        />
        <path
            d="M34.5681 41.0002C32.5947 41.0002 30.9414 39.4002 30.9414 37.3735C30.9414 35.3468 32.5414 33.7468 34.5681 33.7468C36.5947 33.7468 38.1947 35.3468 38.1947 37.3735C38.1947 39.4002 36.5414 41.0002 34.5681 41.0002ZM34.5681 35.4002C33.4481 35.4002 32.5414 36.3068 32.5414 37.4268C32.5414 38.5468 33.4481 39.4535 34.5681 39.4535C35.6881 39.4535 36.5947 38.5468 36.5947 37.4268C36.5947 36.3068 35.6881 35.4002 34.5681 35.4002Z"
            fill="#F9675D"
        />
        <circle cx="47.2744" cy="9" r="9" fill="#F9675D" />
        <path
            d="M47.6669 2.23193H46.9389L41.3389 13.4319L41.7309 14.0479H52.9309L53.3229 13.4319L47.6669 2.23193ZM42.3469 13.2079L47.2749 3.35193L52.2029 13.2079H42.3469Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M47.7228 6.26392H46.8828V10.1839H47.7228V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M47.7785 11.136H46.7705V12.144H47.7785V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174059">
                <path
                    d="M0.274414 29C0.274414 13.536 12.8104 1 28.2744 1V1C43.7384 1 56.2744 13.536 56.2744 29V29C56.2744 44.464 43.7384 57 28.2744 57V57C12.8104 57 0.274414 44.464 0.274414 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayWarningIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174096)">
            <path
                d="M0.65625 22C0.65625 10.402 10.0583 1 21.6562 1V1C33.2542 1 42.6562 10.402 42.6562 22V22C42.6562 33.598 33.2542 43 21.6562 43V43C10.0583 43 0.65625 33.598 0.65625 22V22Z"
                fill="#ED9937"
            />
            <circle cx="21.6562" cy="22" r="20" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M30.1761 21.5199L27.6961 20.9999L26.5361 15.9199L26.4561 15.4399H11.4561V16.0399V28.2799V28.8799H14.8161V27.6799H12.6561V16.6399H21.0561V27.6799H19.0561V28.8799H24.2961V27.6799H22.2961V22.0799H27.1761L29.7361 22.5999C30.2961 22.9199 30.6561 23.5999 30.6561 24.3199V27.6399H28.4961V28.8399H31.8561V28.2399V24.3999C31.8561 23.1199 31.2161 21.9999 30.1761 21.5199ZM22.2561 20.9199V16.6399H25.4961L26.4561 20.9199H22.2561Z"
            fill="#ED9937"
        />
        <path
            d="M16.9358 31.0001C15.4558 31.0001 14.2158 29.8001 14.2158 28.2801C14.2158 26.7601 15.4158 25.5601 16.9358 25.5601C18.4558 25.5601 19.6558 26.7601 19.6558 28.2801C19.6558 29.8001 18.4158 31.0001 16.9358 31.0001ZM16.9358 26.8001C16.0958 26.8001 15.4158 27.4801 15.4158 28.3201C15.4158 29.1601 16.0958 29.8401 16.9358 29.8401C17.7758 29.8401 18.4558 29.1601 18.4558 28.3201C18.4558 27.4801 17.7758 26.8001 16.9358 26.8001Z"
            fill="#ED9937"
        />
        <path
            d="M26.3762 31.0001C24.8962 31.0001 23.6562 29.8001 23.6562 28.2801C23.6562 26.7601 24.8562 25.5601 26.3762 25.5601C27.8962 25.5601 29.0962 26.7601 29.0962 28.2801C29.0962 29.8001 27.8562 31.0001 26.3762 31.0001ZM26.3762 26.8001C25.5362 26.8001 24.8562 27.4801 24.8562 28.3201C24.8562 29.1601 25.5362 29.8401 26.3762 29.8401C27.2162 29.8401 27.8962 29.1601 27.8962 28.3201C27.8962 27.4801 27.2162 26.8001 26.3762 26.8001Z"
            fill="#ED9937"
        />
        <circle cx="35.9062" cy="7" r="6.75" fill="#FFB865" />
        <path
            d="M38.2999 5.87203C38.2999 4.52804 37.2079 3.43604 35.8639 3.43604C34.5199 3.43604 33.4279 4.52804 33.4279 5.87203V7.63603H32.4199V10.576H39.3499V7.63603H38.2999V5.87203ZM34.0999 5.87203C34.0999 4.90604 34.8979 4.10804 35.8639 4.10804C36.8299 4.10804 37.6279 4.90604 37.6279 5.87203V7.63603H34.0999V5.87203ZM38.7199 8.30803V9.98803H33.0919V8.30803H33.5119H38.3419H38.7199Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M36.2423 1.88208H35.6123V2.93208H36.2423V1.88208Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M40.1057 5.78809H39.0557V6.41809H40.1057V5.78809Z" fill="#623602" />
        <path d="M32.7561 5.78809H31.7061V6.41809H32.7561V5.78809Z" fill="#623602" />
        <path d="M38.8557 2.72214L38.1133 3.4646L38.5588 3.91007L39.3012 3.16762L38.8557 2.72214Z" fill="#623602" />
        <path d="M32.9806 2.74203L32.5352 3.1875L33.2776 3.92996L33.7231 3.48448L32.9806 2.74203Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174096">
                <path
                    d="M0.65625 22C0.65625 10.402 10.0583 1 21.6562 1V1C33.2542 1 42.6562 10.402 42.6562 22V22C42.6562 33.598 33.2542 43 21.6562 43V43C10.0583 43 0.65625 33.598 0.65625 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWayWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174093)">
            <path
                d="M0.985352 29C0.985352 13.536 13.5214 1 28.9854 1V1C44.4493 1 56.9854 13.536 56.9854 29V29C56.9854 44.464 44.4493 57 28.9854 57V57C13.5214 57 0.985352 44.464 0.985352 29V29Z"
                fill="#ED9937"
            />
            <circle cx="28.9854" cy="29" r="27" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M40.3457 28.3601L37.0391 27.6668L35.4924 20.8934L35.3857 20.2534H15.3857V21.0534V37.3734V38.1734H19.8657V36.5734H16.9857V21.8534H28.1857V36.5734H25.5191V38.1734H32.5057V36.5734H29.8391V29.1068H36.3457L39.7591 29.8001C40.5057 30.2268 40.9857 31.1334 40.9857 32.0934V36.5201H38.1057V38.1201H42.5857V37.3201V32.2001C42.5857 30.4934 41.7324 29.0001 40.3457 28.3601ZM29.7857 27.5601V21.8534H34.1057L35.3857 27.5601H29.7857Z"
            fill="#ED9937"
        />
        <path
            d="M22.6921 41.0002C20.7188 41.0002 19.0654 39.4002 19.0654 37.3735C19.0654 35.3468 20.6654 33.7468 22.6921 33.7468C24.7188 33.7468 26.3188 35.3468 26.3188 37.3735C26.3188 39.4002 24.6654 41.0002 22.6921 41.0002ZM22.6921 35.4002C21.5721 35.4002 20.6654 36.3068 20.6654 37.4268C20.6654 38.5468 21.5721 39.4535 22.6921 39.4535C23.8121 39.4535 24.7188 38.5468 24.7188 37.4268C24.7188 36.3068 23.8121 35.4002 22.6921 35.4002Z"
            fill="#ED9937"
        />
        <path
            d="M35.279 41.0002C33.3057 41.0002 31.6523 39.4002 31.6523 37.3735C31.6523 35.3468 33.2523 33.7468 35.279 33.7468C37.3057 33.7468 38.9057 35.3468 38.9057 37.3735C38.9057 39.4002 37.2523 41.0002 35.279 41.0002ZM35.279 35.4002C34.159 35.4002 33.2523 36.3068 33.2523 37.4268C33.2523 38.5468 34.159 39.4535 35.279 39.4535C36.399 39.4535 37.3057 38.5468 37.3057 37.4268C37.3057 36.3068 36.399 35.4002 35.279 35.4002Z"
            fill="#ED9937"
        />
        <circle cx="47.9854" cy="9" r="9" fill="#FFB865" />
        <path
            d="M51.1779 7.49605C51.1779 5.70405 49.7219 4.24805 47.9299 4.24805C46.1379 4.24805 44.6819 5.70405 44.6819 7.49605V9.84805H43.3379V13.768H52.5779V9.84805H51.1779V7.49605ZM45.5779 7.49605C45.5779 6.20805 46.6419 5.14405 47.9299 5.14405C49.2179 5.14405 50.2819 6.20805 50.2819 7.49605V9.84805H45.5779V7.49605ZM51.7379 10.744V12.984H44.2339V10.744H44.7939H51.2339H51.7379Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M48.4337 2.17603H47.5938V3.57603H48.4337V2.17603Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M53.5855 7.38403H52.1855V8.22403H53.5855V7.38403Z" fill="#623602" />
        <path d="M43.7857 7.38403H42.3857V8.22403H43.7857V7.38403Z" fill="#623602" />
        <path d="M51.9187 3.29595L50.9287 4.28589L51.5227 4.87985L52.5126 3.88991L51.9187 3.29595Z" fill="#623602" />
        <path d="M44.0852 3.32278L43.4912 3.91675L44.4812 4.90669L45.0751 4.31272L44.0852 3.32278Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174093">
                <path
                    d="M0.985352 29C0.985352 13.536 13.5214 1 28.9854 1V1C44.4493 1 56.9854 13.536 56.9854 29V29C56.9854 44.464 44.4493 57 28.9854 57V57C13.5214 57 0.985352 44.464 0.985352 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWaySuccessIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174028)">
            <path
                d="M0.233398 22C0.233398 10.402 9.63542 1 21.2334 1V1C32.8314 1 42.2334 10.402 42.2334 22V22C42.2334 33.598 32.8314 43 21.2334 43V43C9.63542 43 0.233398 33.598 0.233398 22V22Z"
                fill="#93E191"
            />
            <circle cx="21.2334" cy="22" r="20" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M29.7532 21.5199L27.2732 20.9999L26.1132 15.9199L26.0332 15.4399H11.0332V16.0399V28.2799V28.8799H14.3932V27.6799H12.2332V16.6399H20.6332V27.6799H18.6332V28.8799H23.8732V27.6799H21.8732V22.0799H26.7532L29.3132 22.5999C29.8732 22.9199 30.2332 23.5999 30.2332 24.3199V27.6399H28.0732V28.8399H31.4332V28.2399V24.3999C31.4332 23.1199 30.7932 21.9999 29.7532 21.5199ZM21.8332 20.9199V16.6399H25.0732L26.0332 20.9199H21.8332Z"
            fill="#54C65F"
        />
        <path
            d="M16.513 31.0001C15.033 31.0001 13.793 29.8001 13.793 28.2801C13.793 26.7601 14.993 25.5601 16.513 25.5601C18.033 25.5601 19.233 26.7601 19.233 28.2801C19.233 29.8001 17.993 31.0001 16.513 31.0001ZM16.513 26.8001C15.673 26.8001 14.993 27.4801 14.993 28.3201C14.993 29.1601 15.673 29.8401 16.513 29.8401C17.353 29.8401 18.033 29.1601 18.033 28.3201C18.033 27.4801 17.353 26.8001 16.513 26.8001Z"
            fill="#54C65F"
        />
        <path
            d="M25.9534 31.0001C24.4734 31.0001 23.2334 29.8001 23.2334 28.2801C23.2334 26.7601 24.4334 25.5601 25.9534 25.5601C27.4734 25.5601 28.6734 26.7601 28.6734 28.2801C28.6734 29.8001 27.4334 31.0001 25.9534 31.0001ZM25.9534 26.8001C25.1134 26.8001 24.4334 27.4801 24.4334 28.3201C24.4334 29.1601 25.1134 29.8401 25.9534 29.8401C26.7934 29.8401 27.4734 29.1601 27.4734 28.3201C27.4734 27.4801 26.7934 26.8001 25.9534 26.8001Z"
            fill="#54C65F"
        />
        <circle cx="35.4834" cy="7" r="6.75" fill="#54C65F" />
        <path
            d="M38.4536 4.30005L34.1336 8.56605L32.5136 6.94605L31.9736 7.54005L34.1336 9.70005L38.9936 4.84005L38.4536 4.30005Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174028">
                <path
                    d="M0.233398 22C0.233398 10.402 9.63542 1 21.2334 1V1C32.8314 1 42.2334 10.402 42.2334 22V22C42.2334 33.598 32.8314 43 21.2334 43V43C9.63542 43 0.233398 33.598 0.233398 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const OnTheWaySuccessBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174025)">
            <path
                d="M0.561523 29C0.561523 13.536 13.0976 1 28.5615 1V1C44.0255 1 56.5615 13.536 56.5615 29V29C56.5615 44.464 44.0255 57 28.5615 57V57C13.0976 57 0.561523 44.464 0.561523 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.5615" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M39.9219 28.3601L36.6152 27.6668L35.0686 20.8934L34.9619 20.2534H14.9619V21.0534V37.3734V38.1734H19.4419V36.5734H16.5619V21.8534H27.7619V36.5734H25.0952V38.1734H32.0819V36.5734H29.4152V29.1068H35.9219L39.3352 29.8001C40.0819 30.2268 40.5619 31.1334 40.5619 32.0934V36.5201H37.6819V38.1201H42.1619V37.3201V32.2001C42.1619 30.4934 41.3086 29.0001 39.9219 28.3601ZM29.3619 27.5601V21.8534H33.6819L34.9619 27.5601H29.3619Z"
            fill="#54C65F"
        />
        <path
            d="M22.2683 41.0002C20.2949 41.0002 18.6416 39.4002 18.6416 37.3735C18.6416 35.3468 20.2416 33.7468 22.2683 33.7468C24.2949 33.7468 25.8949 35.3468 25.8949 37.3735C25.8949 39.4002 24.2416 41.0002 22.2683 41.0002ZM22.2683 35.4002C21.1483 35.4002 20.2416 36.3068 20.2416 37.4268C20.2416 38.5468 21.1483 39.4535 22.2683 39.4535C23.3883 39.4535 24.2949 38.5468 24.2949 37.4268C24.2949 36.3068 23.3883 35.4002 22.2683 35.4002Z"
            fill="#54C65F"
        />
        <path
            d="M34.8552 41.0002C32.8818 41.0002 31.2285 39.4002 31.2285 37.3735C31.2285 35.3468 32.8285 33.7468 34.8552 33.7468C36.8818 33.7468 38.4818 35.3468 38.4818 37.3735C38.4818 39.4002 36.8285 41.0002 34.8552 41.0002ZM34.8552 35.4002C33.7352 35.4002 32.8285 36.3068 32.8285 37.4268C32.8285 38.5468 33.7352 39.4535 34.8552 39.4535C35.9752 39.4535 36.8818 38.5468 36.8818 37.4268C36.8818 36.3068 35.9752 35.4002 34.8552 35.4002Z"
            fill="#54C65F"
        />
        <circle cx="47.5615" cy="9" r="9" fill="#54C65F" />
        <path
            d="M51.5218 5.3999L45.7618 11.0879L43.6018 8.9279L42.8818 9.7199L45.7618 12.5999L52.2418 6.1199L51.5218 5.3999Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174025">
                <path
                    d="M0.561523 29C0.561523 13.536 13.0976 1 28.5615 1V1C44.0255 1 56.5615 13.536 56.5615 29V29C56.5615 44.464 44.0255 57 28.5615 57V57C13.0976 57 0.561523 44.464 0.561523 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedOkIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173957)">
            <path
                d="M0.780273 21C0.780273 9.40202 10.1823 0 21.7803 0V0C33.3783 0 42.7803 9.40202 42.7803 21V21C42.7803 32.598 33.3783 42 21.7803 42V42C10.1823 42 0.780273 32.598 0.780273 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.7803" cy="21" r="20" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M21.5 26.56H20.66L19.54 25.48L20.42 24.6L21.06 25.28L23.1 23.24L23.98 24.08L21.5 26.56Z"
            fill={colors.primary_O}
        />
        <path
            d="M21.7801 29.0399C19.4601 29.0399 17.5801 27.1599 17.5801 24.8399C17.5801 22.5199 19.4601 20.6399 21.7801 20.6399C24.1001 20.6399 25.9801 22.5199 25.9801 24.8399C25.9801 27.1599 24.1001 29.0399 21.7801 29.0399ZM21.7801 21.8399C20.1401 21.8399 18.7801 23.1999 18.7801 24.8399C18.7801 26.4799 20.1401 27.8399 21.7801 27.8399C23.4201 27.8399 24.7801 26.4799 24.7801 24.8399C24.7801 23.1999 23.4201 21.8399 21.7801 21.8399Z"
            fill={colors.primary_O}
        />
        <path
            d="M31.9801 18.92L31.9001 18.8L29.0601 13.52L28.8601 13.2H14.6601L14.5001 13.52L11.6601 18.8L11.5801 18.92V19.08V30.6V31.2H31.9801V30.6V19.08V18.92ZM15.6201 14.4H27.9801V18.48H15.6201V14.4ZM29.1401 16.2L30.3801 18.48H29.1401V16.2ZM14.4201 16.2V18.48H13.1801L14.4201 16.2ZM30.7801 30H12.7801V19.68H30.7801V30Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173957">
                <path
                    d="M0.780273 21C0.780273 9.40202 10.1823 0 21.7803 0V0C33.3783 0 42.7803 9.40202 42.7803 21V21C42.7803 32.598 33.3783 42 21.7803 42V42C10.1823 42 0.780273 32.598 0.780273 21V21Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedOkBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173953)">
            <path
                d="M0.109375 28C0.109375 12.536 12.6454 0 28.1094 0V0C43.5733 0 56.1094 12.536 56.1094 28V28C56.1094 43.464 43.5733 56 28.1094 56V56C12.6454 56 0.109375 43.464 0.109375 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.1094" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M27.7364 35.4135H26.6164L25.123 33.9735L26.2964 32.8002L27.1497 33.7068L29.8697 30.9868L31.043 32.1068L27.7364 35.4135Z"
            fill={colors.primary_O}
        />
        <path
            d="M28.1098 38.72C25.0164 38.72 22.5098 36.2134 22.5098 33.12C22.5098 30.0267 25.0164 27.52 28.1098 27.52C31.2031 27.52 33.7098 30.0267 33.7098 33.12C33.7098 36.2134 31.2031 38.72 28.1098 38.72ZM28.1098 29.12C25.9231 29.12 24.1098 30.9334 24.1098 33.12C24.1098 35.3067 25.9231 37.12 28.1098 37.12C30.2964 37.12 32.1098 35.3067 32.1098 33.12C32.1098 30.9334 30.2964 29.12 28.1098 29.12Z"
            fill={colors.primary_O}
        />
        <path
            d="M41.7098 25.2268L41.6031 25.0668L37.8164 18.0268L37.5498 17.6001H18.6164L18.4031 18.0268L14.6164 25.0668L14.5098 25.2268V25.4401V40.8001V41.6001H41.7098V40.8001V25.4401V25.2268ZM19.8964 19.2001H36.3764V24.6401H19.8964V19.2001ZM37.9231 21.6001L39.5764 24.6401H37.9231V21.6001ZM18.2964 21.6001V24.6401H16.6431L18.2964 21.6001ZM40.1098 40.0001H16.1098V26.2401H40.1098V40.0001Z"
            fill={colors.icon}
        />
        <defs>
            <clipPath id="clip0_13649_173953">
                <path
                    d="M0.109375 28C0.109375 12.536 12.6454 0 28.1094 0V0C43.5733 0 56.1094 12.536 56.1094 28V28C56.1094 43.464 43.5733 56 28.1094 56V56C12.6454 56 0.109375 43.464 0.109375 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedOkWithWarningBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173953)">
            <path
                d="M0.109375 28C0.109375 12.536 12.6454 0 28.1094 0V0C43.5733 0 56.1094 12.536 56.1094 28V28C56.1094 43.464 43.5733 56 28.1094 56V56C12.6454 56 0.109375 43.464 0.109375 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.1094" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <path
            d="M27.7364 35.4135H26.6164L25.123 33.9735L26.2964 32.8002L27.1497 33.7068L29.8697 30.9868L31.043 32.1068L27.7364 35.4135Z"
            fill={colors.primary_O}
        />
        <path
            d="M28.1098 38.72C25.0164 38.72 22.5098 36.2134 22.5098 33.12C22.5098 30.0267 25.0164 27.52 28.1098 27.52C31.2031 27.52 33.7098 30.0267 33.7098 33.12C33.7098 36.2134 31.2031 38.72 28.1098 38.72ZM28.1098 29.12C25.9231 29.12 24.1098 30.9334 24.1098 33.12C24.1098 35.3067 25.9231 37.12 28.1098 37.12C30.2964 37.12 32.1098 35.3067 32.1098 33.12C32.1098 30.9334 30.2964 29.12 28.1098 29.12Z"
            fill={colors.primary_O}
        />
        <path
            d="M41.7098 25.2268L41.6031 25.0668L37.8164 18.0268L37.5498 17.6001H18.6164L18.4031 18.0268L14.6164 25.0668L14.5098 25.2268V25.4401V40.8001V41.6001H41.7098V40.8001V25.4401V25.2268ZM19.8964 19.2001H36.3764V24.6401H19.8964V19.2001ZM37.9231 21.6001L39.5764 24.6401H37.9231V21.6001ZM18.2964 21.6001V24.6401H16.6431L18.2964 21.6001ZM40.1098 40.0001H16.1098V26.2401H40.1098V40.0001Z"
            fill={colors.icon}
        />
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_173953">
                <path
                    d="M0.109375 28C0.109375 12.536 12.6454 0 28.1094 0V0C43.5733 0 56.1094 12.536 56.1094 28V28C56.1094 43.464 43.5733 56 28.1094 56V56C12.6454 56 0.109375 43.464 0.109375 28V28Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedDisabledIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.493164 21C0.493164 9.40202 9.89518 0 21.4932 0V0C33.0911 0 42.4932 9.40202 42.4932 21V21C42.4932 32.598 33.0911 42 21.4932 42V42C9.89518 42 0.493164 32.598 0.493164 21V21Z"
            fill="#F6F9FF"
        />
        <path
            d="M21.2129 26.56H20.3729L19.2529 25.48L20.1329 24.6L20.7729 25.28L22.8129 23.24L23.6929 24.08L21.2129 26.56Z"
            fill="#7E8CB2"
        />
        <path
            d="M21.493 29.0399C19.173 29.0399 17.293 27.1599 17.293 24.8399C17.293 22.5199 19.173 20.6399 21.493 20.6399C23.813 20.6399 25.693 22.5199 25.693 24.8399C25.693 27.1599 23.813 29.0399 21.493 29.0399ZM21.493 21.8399C19.853 21.8399 18.493 23.1999 18.493 24.8399C18.493 26.4799 19.853 27.8399 21.493 27.8399C23.133 27.8399 24.493 26.4799 24.493 24.8399C24.493 23.1999 23.133 21.8399 21.493 21.8399Z"
            fill="#7E8CB2"
        />
        <path
            d="M31.693 18.92L31.613 18.8L28.773 13.52L28.573 13.2H14.373L14.213 13.52L11.373 18.8L11.293 18.92V19.08V30.6V31.2H31.693V30.6V19.08V18.92ZM15.333 14.4H27.693V18.48H15.333V14.4ZM28.853 16.2L30.093 18.48H28.853V16.2ZM14.133 16.2V18.48H12.893L14.133 16.2ZM30.493 30H12.493V19.68H30.493V30Z"
            fill="#7E8CB2"
        />
    </svg>
);
export const ReceivedDisabledBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.821289 28C0.821289 12.536 13.3573 0 28.8213 0V0C44.2853 0 56.8213 12.536 56.8213 28V28C56.8213 43.464 44.2853 56 28.8213 56V56C13.3573 56 0.821289 43.464 0.821289 28V28Z"
            fill="#F6F9FF"
        />
        <path
            d="M28.4483 35.4135H27.3283L25.835 33.9735L27.0083 32.8002L27.8616 33.7068L30.5816 30.9868L31.755 32.1068L28.4483 35.4135Z"
            fill="#7E8CB2"
        />
        <path
            d="M28.8217 38.72C25.7283 38.72 23.2217 36.2134 23.2217 33.12C23.2217 30.0267 25.7283 27.52 28.8217 27.52C31.915 27.52 34.4217 30.0267 34.4217 33.12C34.4217 36.2134 31.915 38.72 28.8217 38.72ZM28.8217 29.12C26.635 29.12 24.8217 30.9334 24.8217 33.12C24.8217 35.3067 26.635 37.12 28.8217 37.12C31.0083 37.12 32.8217 35.3067 32.8217 33.12C32.8217 30.9334 31.0083 29.12 28.8217 29.12Z"
            fill="#7E8CB2"
        />
        <path
            d="M42.4217 25.2268L42.315 25.0668L38.5283 18.0268L38.2617 17.6001H19.3283L19.115 18.0268L15.3283 25.0668L15.2217 25.2268V25.4401V40.8001V41.6001H42.4217V40.8001V25.4401V25.2268ZM20.6083 19.2001H37.0883V24.6401H20.6083V19.2001ZM38.635 21.6001L40.2883 24.6401H38.635V21.6001ZM19.0083 21.6001V24.6401H17.355L19.0083 21.6001ZM40.8217 40.0001H16.8217V26.2401H40.8217V40.0001Z"
            fill="#7E8CB2"
        />
    </svg>
);
export const ReceivedErrorIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174042)">
            <path
                d="M0.917969 22C0.917969 10.402 10.32 1 21.918 1V1C33.5159 1 42.918 10.402 42.918 22V22C42.918 33.598 33.5159 43 21.918 43V43C10.32 43 0.917969 33.598 0.917969 22V22Z"
                fill="#F9675D"
            />
            <circle cx="21.918" cy="22" r="20" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M21.6377 27.56H20.7977L19.6777 26.48L20.5577 25.6L21.1977 26.28L23.2377 24.24L24.1177 25.08L21.6377 27.56Z"
            fill="#F9675D"
        />
        <path
            d="M21.9178 30.0399C19.5978 30.0399 17.7178 28.1599 17.7178 25.8399C17.7178 23.5199 19.5978 21.6399 21.9178 21.6399C24.2378 21.6399 26.1178 23.5199 26.1178 25.8399C26.1178 28.1599 24.2378 30.0399 21.9178 30.0399ZM21.9178 22.8399C20.2778 22.8399 18.9178 24.1999 18.9178 25.8399C18.9178 27.4799 20.2778 28.8399 21.9178 28.8399C23.5578 28.8399 24.9178 27.4799 24.9178 25.8399C24.9178 24.1999 23.5578 22.8399 21.9178 22.8399Z"
            fill="#F9675D"
        />
        <path
            d="M32.1178 19.92L32.0378 19.8L29.1978 14.52L28.9978 14.2H14.7978L14.6378 14.52L11.7978 19.8L11.7178 19.92V20.08V31.6V32.2H32.1178V31.6V20.08V19.92ZM15.7578 15.4H28.1178V19.48H15.7578V15.4ZM29.2778 17.2L30.5178 19.48H29.2778V17.2ZM14.5578 17.2V19.48H13.3178L14.5578 17.2ZM30.9178 31H12.9178V20.68H30.9178V31Z"
            fill="#F9675D"
        />
        <circle cx="33.918" cy="9" r="9" fill="#F9675D" />
        <g clipPath="url(#clip1_13649_174042)">
            <path
                d="M34.3104 2.23193H33.5824L27.9824 13.4319L28.3744 14.0479H39.5744L39.9664 13.4319L34.3104 2.23193ZM28.9904 13.2079L33.9184 3.35193L38.8464 13.2079H28.9904Z"
                fill="white"
                stroke="white"
                strokeWidth="0.2"
            />
            <path d="M34.3664 6.26392H33.5264V10.1839H34.3664V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
            <path d="M34.4221 11.136H33.4141V12.144H34.4221V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        </g>
        <defs>
            <clipPath id="clip0_13649_174042">
                <path
                    d="M0.917969 22C0.917969 10.402 10.32 1 21.918 1V1C33.5159 1 42.918 10.402 42.918 22V22C42.918 33.598 33.5159 43 21.918 43V43C10.32 43 0.917969 33.598 0.917969 22V22Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174042">
                <rect width="14" height="14" fill="white" transform="translate(26.918 1)" />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedErrorBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174037)">
            <path
                d="M0.24707 29C0.24707 13.536 12.7831 1 28.2471 1V1C43.711 1 56.2471 13.536 56.2471 29V29C56.2471 44.464 43.711 57 28.2471 57V57C12.7831 57 0.24707 44.464 0.24707 29V29Z"
                fill="#F9675D"
            />
            <circle cx="28.2471" cy="29" r="27" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <path
            d="M27.8741 36.4135H26.7541L25.2607 34.9735L26.4341 33.8002L27.2874 34.7068L30.0074 31.9868L31.1807 33.1068L27.8741 36.4135Z"
            fill="#F9675D"
        />
        <path
            d="M28.2475 39.72C25.1541 39.72 22.6475 37.2134 22.6475 34.12C22.6475 31.0267 25.1541 28.52 28.2475 28.52C31.3408 28.52 33.8475 31.0267 33.8475 34.12C33.8475 37.2134 31.3408 39.72 28.2475 39.72ZM28.2475 30.12C26.0608 30.12 24.2475 31.9334 24.2475 34.12C24.2475 36.3067 26.0608 38.12 28.2475 38.12C30.4341 38.12 32.2475 36.3067 32.2475 34.12C32.2475 31.9334 30.4341 30.12 28.2475 30.12Z"
            fill="#F9675D"
        />
        <path
            d="M41.8475 26.2268L41.7408 26.0668L37.9541 19.0268L37.6875 18.6001H18.7541L18.5408 19.0268L14.7541 26.0668L14.6475 26.2268V26.4401V41.8001V42.6001H41.8475V41.8001V26.4401V26.2268ZM20.0341 20.2001H36.5141V25.6401H20.0341V20.2001ZM38.0608 22.6001L39.7141 25.6401H38.0608V22.6001ZM18.4341 22.6001V25.6401H16.7808L18.4341 22.6001ZM40.2475 41.0001H16.2475V27.2401H40.2475V41.0001Z"
            fill="#F9675D"
        />
        <circle cx="47.2471" cy="9" r="9" fill="#F9675D" />
        <path
            d="M47.6395 2.23193H46.9115L41.3115 13.4319L41.7035 14.0479H52.9035L53.2955 13.4319L47.6395 2.23193ZM42.3195 13.2079L47.2475 3.35193L52.1755 13.2079H42.3195Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M47.6955 6.26392H46.8555V10.1839H47.6955V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M47.7512 11.136H46.7432V12.144H47.7512V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174037">
                <path
                    d="M0.24707 29C0.24707 13.536 12.7831 1 28.2471 1V1C43.711 1 56.2471 13.536 56.2471 29V29C56.2471 44.464 43.711 57 28.2471 57V57C12.7831 57 0.24707 44.464 0.24707 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedWarningIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174076)">
            <path
                d="M0.629883 22C0.629883 10.402 10.0319 1 21.6299 1V1C33.2279 1 42.6299 10.402 42.6299 22V22C42.6299 33.598 33.2279 43 21.6299 43V43C10.0319 43 0.629883 33.598 0.629883 22V22Z"
                fill="#ED9937"
            />
            <circle cx="21.6299" cy="22" r="20" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M21.3496 27.56H20.5096L19.3896 26.48L20.2696 25.6L20.9096 26.28L22.9496 24.24L23.8296 25.08L21.3496 27.56Z"
            fill="#ED9937"
        />
        <path
            d="M21.6297 30.0399C19.3097 30.0399 17.4297 28.1599 17.4297 25.8399C17.4297 23.5199 19.3097 21.6399 21.6297 21.6399C23.9497 21.6399 25.8297 23.5199 25.8297 25.8399C25.8297 28.1599 23.9497 30.0399 21.6297 30.0399ZM21.6297 22.8399C19.9897 22.8399 18.6297 24.1999 18.6297 25.8399C18.6297 27.4799 19.9897 28.8399 21.6297 28.8399C23.2697 28.8399 24.6297 27.4799 24.6297 25.8399C24.6297 24.1999 23.2697 22.8399 21.6297 22.8399Z"
            fill="#ED9937"
        />
        <path
            d="M31.8297 19.92L31.7497 19.8L28.9097 14.52L28.7097 14.2H14.5097L14.3497 14.52L11.5097 19.8L11.4297 19.92V20.08V31.6V32.2H31.8297V31.6V20.08V19.92ZM15.4697 15.4H27.8297V19.48H15.4697V15.4ZM28.9897 17.2L30.2297 19.48H28.9897V17.2ZM14.2697 17.2V19.48H13.0297L14.2697 17.2ZM30.6297 31H12.6297V20.68H30.6297V31Z"
            fill="#ED9937"
        />
        <circle cx="35.8799" cy="7" r="6.75" fill="#FFB865" />
        <path
            d="M38.2736 5.87203C38.2736 4.52804 37.1816 3.43604 35.8376 3.43604C34.4936 3.43604 33.4016 4.52804 33.4016 5.87203V7.63603H32.3936V10.576H39.3236V7.63603H38.2736V5.87203ZM34.0736 5.87203C34.0736 4.90604 34.8716 4.10804 35.8376 4.10804C36.8036 4.10804 37.6016 4.90604 37.6016 5.87203V7.63603H34.0736V5.87203ZM38.6936 8.30803V9.98803H33.0656V8.30803H33.4856H38.3156H38.6936Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M36.2159 1.88208H35.5859V2.93208H36.2159V1.88208Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M40.0793 5.78809H39.0293V6.41809H40.0793V5.78809Z" fill="#623602" />
        <path d="M32.7297 5.78809H31.6797V6.41809H32.7297V5.78809Z" fill="#623602" />
        <path d="M38.8294 2.72214L38.0869 3.4646L38.5324 3.91007L39.2748 3.16762L38.8294 2.72214Z" fill="#623602" />
        <path d="M32.9543 2.74203L32.5088 3.1875L33.2512 3.92996L33.6967 3.48448L32.9543 2.74203Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174076">
                <path
                    d="M0.629883 22C0.629883 10.402 10.0319 1 21.6299 1V1C33.2279 1 42.6299 10.402 42.6299 22V22C42.6299 33.598 33.2279 43 21.6299 43V43C10.0319 43 0.629883 33.598 0.629883 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174071)">
            <path
                d="M0.958984 29C0.958984 13.536 13.495 1 28.959 1V1C44.423 1 56.959 13.536 56.959 29V29C56.959 44.464 44.423 57 28.959 57V57C13.495 57 0.958984 44.464 0.958984 29V29Z"
                fill="#ED9937"
            />
            <circle cx="28.959" cy="29" r="27" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <path
            d="M28.586 36.4135H27.466L25.9727 34.9735L27.146 33.8002L27.9993 34.7068L30.7193 31.9868L31.8927 33.1068L28.586 36.4135Z"
            fill="#ED9937"
        />
        <path
            d="M28.9594 39.72C25.866 39.72 23.3594 37.2134 23.3594 34.12C23.3594 31.0267 25.866 28.52 28.9594 28.52C32.0527 28.52 34.5594 31.0267 34.5594 34.12C34.5594 37.2134 32.0527 39.72 28.9594 39.72ZM28.9594 30.12C26.7727 30.12 24.9594 31.9334 24.9594 34.12C24.9594 36.3067 26.7727 38.12 28.9594 38.12C31.146 38.12 32.9594 36.3067 32.9594 34.12C32.9594 31.9334 31.146 30.12 28.9594 30.12Z"
            fill="#ED9937"
        />
        <path
            d="M42.5594 26.2268L42.4527 26.0668L38.666 19.0268L38.3994 18.6001H19.466L19.2527 19.0268L15.466 26.0668L15.3594 26.2268V26.4401V41.8001V42.6001H42.5594V41.8001V26.4401V26.2268ZM20.746 20.2001H37.226V25.6401H20.746V20.2001ZM38.7727 22.6001L40.426 25.6401H38.7727V22.6001ZM19.146 22.6001V25.6401H17.4927L19.146 22.6001ZM40.9594 41.0001H16.9594V27.2401H40.9594V41.0001Z"
            fill="#ED9937"
        />
        <circle cx="47.959" cy="9" r="9" fill="#FFB865" />
        <path
            d="M51.1515 7.49605C51.1515 5.70405 49.6955 4.24805 47.9035 4.24805C46.1115 4.24805 44.6555 5.70405 44.6555 7.49605V9.84805H43.3115V13.768H52.5515V9.84805H51.1515V7.49605ZM45.5515 7.49605C45.5515 6.20805 46.6155 5.14405 47.9035 5.14405C49.1915 5.14405 50.2555 6.20805 50.2555 7.49605V9.84805H45.5515V7.49605ZM51.7115 10.744V12.984H44.2075V10.744H44.7675H51.2075H51.7115Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M48.4074 2.17603H47.5674V3.57603H48.4074V2.17603Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M53.5592 7.38403H52.1592V8.22403H53.5592V7.38403Z" fill="#623602" />
        <path d="M43.7594 7.38403H42.3594V8.22403H43.7594V7.38403Z" fill="#623602" />
        <path d="M51.8923 3.29595L50.9023 4.28589L51.4963 4.87985L52.4862 3.88991L51.8923 3.29595Z" fill="#623602" />
        <path d="M44.0588 3.32278L43.4648 3.91675L44.4548 4.90669L45.0487 4.31272L44.0588 3.32278Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174071">
                <path
                    d="M0.958984 29C0.958984 13.536 13.495 1 28.959 1V1C44.423 1 56.959 13.536 56.959 29V29C56.959 44.464 44.423 57 28.959 57V57C13.495 57 0.958984 44.464 0.958984 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedSuccessIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174008)">
            <path
                d="M0.205078 22C0.205078 10.402 9.6071 1 21.2051 1V1C32.8031 1 42.2051 10.402 42.2051 22V22C42.2051 33.598 32.8031 43 21.2051 43V43C9.6071 43 0.205078 33.598 0.205078 22V22Z"
                fill="#93E191"
            />
            <circle cx="21.2051" cy="22" r="20" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M20.9248 27.56H20.0848L18.9648 26.48L19.8448 25.6L20.4848 26.28L22.5248 24.24L23.4048 25.08L20.9248 27.56Z"
            fill="#54C65F"
        />
        <path
            d="M21.2049 30.0399C18.8849 30.0399 17.0049 28.1599 17.0049 25.8399C17.0049 23.5199 18.8849 21.6399 21.2049 21.6399C23.5249 21.6399 25.4049 23.5199 25.4049 25.8399C25.4049 28.1599 23.5249 30.0399 21.2049 30.0399ZM21.2049 22.8399C19.5649 22.8399 18.2049 24.1999 18.2049 25.8399C18.2049 27.4799 19.5649 28.8399 21.2049 28.8399C22.8449 28.8399 24.2049 27.4799 24.2049 25.8399C24.2049 24.1999 22.8449 22.8399 21.2049 22.8399Z"
            fill="#54C65F"
        />
        <path
            d="M31.4049 19.92L31.3249 19.8L28.4849 14.52L28.2849 14.2H14.0849L13.9249 14.52L11.0849 19.8L11.0049 19.92V20.08V31.6V32.2H31.4049V31.6V20.08V19.92ZM15.0449 15.4H27.4049V19.48H15.0449V15.4ZM28.5649 17.2L29.8049 19.48H28.5649V17.2ZM13.8449 17.2V19.48H12.6049L13.8449 17.2ZM30.2049 31H12.2049V20.68H30.2049V31Z"
            fill="#54C65F"
        />
        <circle cx="35.4551" cy="7" r="6.75" fill="#54C65F" />
        <path
            d="M38.4253 4.30005L34.1053 8.56605L32.4853 6.94605L31.9453 7.54005L34.1053 9.70005L38.9653 4.84005L38.4253 4.30005Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174008">
                <path
                    d="M0.205078 22C0.205078 10.402 9.6071 1 21.2051 1V1C32.8031 1 42.2051 10.402 42.2051 22V22C42.2051 33.598 32.8031 43 21.2051 43V43C9.6071 43 0.205078 33.598 0.205078 22V22Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ReceivedSuccessBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174003)">
            <path
                d="M0.53418 29C0.53418 13.536 13.0702 1 28.5342 1V1C43.9982 1 56.5342 13.536 56.5342 29V29C56.5342 44.464 43.9982 57 28.5342 57V57C13.0702 57 0.53418 44.464 0.53418 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.5342" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <path
            d="M28.1612 36.4135H27.0412L25.5479 34.9735L26.7212 33.8002L27.5745 34.7068L30.2945 31.9868L31.4679 33.1068L28.1612 36.4135Z"
            fill="#54C65F"
        />
        <path
            d="M28.5346 39.72C25.4412 39.72 22.9346 37.2134 22.9346 34.12C22.9346 31.0267 25.4412 28.52 28.5346 28.52C31.6279 28.52 34.1346 31.0267 34.1346 34.12C34.1346 37.2134 31.6279 39.72 28.5346 39.72ZM28.5346 30.12C26.3479 30.12 24.5346 31.9334 24.5346 34.12C24.5346 36.3067 26.3479 38.12 28.5346 38.12C30.7212 38.12 32.5346 36.3067 32.5346 34.12C32.5346 31.9334 30.7212 30.12 28.5346 30.12Z"
            fill="#54C65F"
        />
        <path
            d="M42.1346 26.2268L42.0279 26.0668L38.2412 19.0268L37.9746 18.6001H19.0412L18.8279 19.0268L15.0412 26.0668L14.9346 26.2268V26.4401V41.8001V42.6001H42.1346V41.8001V26.4401V26.2268ZM20.3212 20.2001H36.8012V25.6401H20.3212V20.2001ZM38.3479 22.6001L40.0012 25.6401H38.3479V22.6001ZM18.7212 22.6001V25.6401H17.0679L18.7212 22.6001ZM40.5346 41.0001H16.5346V27.2401H40.5346V41.0001Z"
            fill="#54C65F"
        />
        <circle cx="47.5342" cy="9" r="9" fill="#54C65F" />
        <path
            d="M51.4945 5.3999L45.7345 11.0879L43.5745 8.9279L42.8545 9.7199L45.7345 12.5999L52.2145 6.1199L51.4945 5.3999Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174003">
                <path
                    d="M0.53418 29C0.53418 13.536 13.0702 1 28.5342 1V1C43.9982 1 56.5342 13.536 56.5342 29V29C56.5342 44.464 43.9982 57 28.5342 57V57C13.0702 57 0.53418 44.464 0.53418 29V29Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingOkIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173963)">
            <path
                d="M0.123047 21C0.123047 9.40202 9.52507 0 21.123 0V0C32.721 0 42.123 9.40202 42.123 21V21C42.123 32.598 32.721 42 21.123 42V42C9.52507 42 0.123047 32.598 0.123047 21V21Z"
                fill="#F6F9FF"
            />
            <circle cx="21.123" cy="21" r="20" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_173963)">
            <path
                d="M23.4029 15.0799L21.7229 16.7599V11.3999H20.5229V16.7599L18.8429 15.0799L18.0029 15.9199L20.6829 18.6399H21.5629L24.2429 15.9199L23.4029 15.0799Z"
                fill={colors.primary_O}
            />
            <path
                d="M32.4433 19.36L30.4033 16.68C30.3633 16.6 30.2833 16.52 30.1633 16.48L26.7633 15L26.3233 16.12L28.4033 17.04L21.1233 19.92L13.8833 17.04L15.9633 16.12L15.4833 15.04L12.1233 16.52C12.0433 16.56 11.9633 16.64 11.8833 16.72L9.84328 19.4L9.36328 20.04L10.9633 20.68V26.92L11.3233 27.08L20.9233 31.2L21.1633 31.32L21.4033 31.2L31.0033 27.08L31.3633 26.92V20.64L32.9633 20L32.4433 19.36ZM23.3633 22.52L22.0833 20.84L29.7233 17.8L31.0033 19.48L23.3633 22.52ZM12.5233 17.8L14.8033 18.72L20.1633 20.84L18.8833 22.52L11.2433 19.48L12.5233 17.8ZM12.1233 21.12L19.3233 23.96L19.5633 23.6L20.5233 22.32V29.68L12.1233 26.08V21.12ZM30.1233 26.08L21.7233 29.68V22.32L22.6833 23.6L22.9633 23.96L30.1233 21.12V26.08Z"
                fill={colors.icon}
            />
        </g>
        <defs>
            <clipPath id="clip0_13649_173963">
                <path
                    d="M0.123047 21C0.123047 9.40202 9.52507 0 21.123 0V0C32.721 0 42.123 9.40202 42.123 21V21C42.123 32.598 32.721 42 21.123 42V42C9.52507 42 0.123047 32.598 0.123047 21V21Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_173963">
                <rect width="24" height="24" fill="white" transform="translate(9.12305 9)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingOkBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173961)">
            <path
                d="M0.452148 28C0.452148 12.536 12.9882 0 28.4521 0V0C43.9161 0 56.4521 12.536 56.4521 28V28C56.4521 43.464 43.9161 56 28.4521 56V56C12.9882 56 0.452148 43.464 0.452148 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.4521" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_173961)">
            <path
                d="M31.492 20.1066L29.252 22.3466V15.2H27.652V22.3466L25.412 20.1066L24.292 21.2266L27.8653 24.8533H29.0387L32.612 21.2266L31.492 20.1066Z"
                fill={colors.primary_O}
            />
            <path
                d="M43.5458 25.8133L40.8258 22.24C40.7725 22.1333 40.6658 22.0267 40.5058 21.9733L35.9725 20L35.3858 21.4933L38.1591 22.72L28.4525 26.56L18.7991 22.72L21.5725 21.4933L20.9325 20.0533L16.4525 22.0267C16.3458 22.08 16.2391 22.1867 16.1325 22.2933L13.4125 25.8667L12.7725 26.72L14.9058 27.5733V35.8933L15.3858 36.1067L28.1858 41.6L28.5058 41.76L28.8258 41.6L41.6258 36.1067L42.1058 35.8933V27.52L44.2391 26.6667L43.5458 25.8133ZM31.4391 30.0267L29.7325 27.7867L39.9191 23.7333L41.6258 25.9733L31.4391 30.0267ZM16.9858 23.7333L20.0258 24.96L27.1725 27.7867L25.4658 30.0267L15.2791 25.9733L16.9858 23.7333ZM16.4525 28.16L26.0525 31.9467L26.3725 31.4667L27.6525 29.76V39.5733L16.4525 34.7733V28.16ZM40.4525 34.7733L29.2525 39.5733V29.76L30.5325 31.4667L30.9058 31.9467L40.4525 28.16V34.7733Z"
                fill={colors.icon}
            />
        </g>
        <defs>
            <clipPath id="clip0_13649_173961">
                <path
                    d="M0.452148 28C0.452148 12.536 12.9882 0 28.4521 0V0C43.9161 0 56.4521 12.536 56.4521 28V28C56.4521 43.464 43.9161 56 28.4521 56V56C12.9882 56 0.452148 43.464 0.452148 28V28Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_173961">
                <rect width="32" height="32" fill="white" transform="translate(12.4521 12)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingOkWithWarningBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173961)">
            <path
                d="M0.452148 28C0.452148 12.536 12.9882 0 28.4521 0V0C43.9161 0 56.4521 12.536 56.4521 28V28C56.4521 43.464 43.9161 56 28.4521 56V56C12.9882 56 0.452148 43.464 0.452148 28V28Z"
                fill="#F6F9FF"
            />
            <circle cx="28.4521" cy="28" r="27" fill="#F8F9FE" stroke="#E7EBF4" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_173961)">
            <path
                d="M31.492 20.1066L29.252 22.3466V15.2H27.652V22.3466L25.412 20.1066L24.292 21.2266L27.8653 24.8533H29.0387L32.612 21.2266L31.492 20.1066Z"
                fill={colors.primary_O}
            />
            <path
                d="M43.5458 25.8133L40.8258 22.24C40.7725 22.1333 40.6658 22.0267 40.5058 21.9733L35.9725 20L35.3858 21.4933L38.1591 22.72L28.4525 26.56L18.7991 22.72L21.5725 21.4933L20.9325 20.0533L16.4525 22.0267C16.3458 22.08 16.2391 22.1867 16.1325 22.2933L13.4125 25.8667L12.7725 26.72L14.9058 27.5733V35.8933L15.3858 36.1067L28.1858 41.6L28.5058 41.76L28.8258 41.6L41.6258 36.1067L42.1058 35.8933V27.52L44.2391 26.6667L43.5458 25.8133ZM31.4391 30.0267L29.7325 27.7867L39.9191 23.7333L41.6258 25.9733L31.4391 30.0267ZM16.9858 23.7333L20.0258 24.96L27.1725 27.7867L25.4658 30.0267L15.2791 25.9733L16.9858 23.7333ZM16.4525 28.16L26.0525 31.9467L26.3725 31.4667L27.6525 29.76V39.5733L16.4525 34.7733V28.16ZM40.4525 34.7733L29.2525 39.5733V29.76L30.5325 31.4667L30.9058 31.9467L40.4525 28.16V34.7733Z"
                fill={colors.icon}
            />
        </g>
        <ellipse strokeWidth="0" fill="#ffb865" cx="47.8" cy="9.15" rx="9.16" ry="9.15" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2px"
            d="m51.05,7.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" stroke="#623602" strokeWidth=".2px" d="m48.25,2.22h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m53.5,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m43.53,7.51h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m51.8,3.35l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m43.83,3.38l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <defs>
            <clipPath id="clip0_13649_173961">
                <path
                    d="M0.452148 28C0.452148 12.536 12.9882 0 28.4521 0V0C43.9161 0 56.4521 12.536 56.4521 28V28C56.4521 43.464 43.9161 56 28.4521 56V56C12.9882 56 0.452148 43.464 0.452148 28V28Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_173961">
                <rect width="32" height="32" fill="white" transform="translate(12.4521 12)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingDisabledIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173989)">
            <circle cx="21.8359" cy="21" r="21" fill="#F8F9FE" />
        </g>
        <g clipPath="url(#clip1_13649_173989)">
            <path
                d="M24.1158 15.0799L22.4358 16.7599V11.3999H21.2358V16.7599L19.5558 15.0799L18.7158 15.9199L21.3958 18.6399H22.2758L24.9558 15.9199L24.1158 15.0799Z"
                fill="#7E8CB2"
            />
            <path
                d="M33.1562 19.36L31.1162 16.68C31.0762 16.6 30.9962 16.52 30.8762 16.48L27.4762 15L27.0362 16.12L29.1162 17.04L21.8362 19.92L14.5962 17.04L16.6762 16.12L16.1962 15.04L12.8362 16.52C12.7562 16.56 12.6762 16.64 12.5962 16.72L10.5562 19.4L10.0762 20.04L11.6762 20.68V26.92L12.0362 27.08L21.6362 31.2L21.8762 31.32L22.1162 31.2L31.7162 27.08L32.0762 26.92V20.64L33.6762 20L33.1562 19.36ZM24.0762 22.52L22.7962 20.84L30.4362 17.8L31.7162 19.48L24.0762 22.52ZM13.2362 17.8L15.5162 18.72L20.8762 20.84L19.5962 22.52L11.9562 19.48L13.2362 17.8ZM12.8362 21.12L20.0362 23.96L20.2762 23.6L21.2362 22.32V29.68L12.8362 26.08V21.12ZM30.8362 26.08L22.4362 29.68V22.32L23.3962 23.6L23.6762 23.96L30.8362 21.12V26.08Z"
                fill="#7E8CB2"
            />
        </g>
        <defs>
            <clipPath id="clip0_13649_173989">
                <path
                    d="M0.835938 21C0.835938 9.40202 10.238 0 21.8359 0V0C33.4339 0 42.8359 9.40202 42.8359 21V21C42.8359 32.598 33.4339 42 21.8359 42V42C10.238 42 0.835938 32.598 0.835938 21V21Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_173989">
                <rect width="24" height="24" fill="white" transform="translate(9.83594 9)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingDisabledBigIcon = () => (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_173987)">
            <circle cx="28.1641" cy="28" r="28" fill="#F8F9FE" />
        </g>
        <g clipPath="url(#clip1_13649_173987)">
            <path
                d="M31.2039 20.1066L28.9639 22.3466V15.2H27.3639V22.3466L25.1239 20.1066L24.0039 21.2266L27.5772 24.8533H28.7506L32.3239 21.2266L31.2039 20.1066Z"
                fill="#7E8CB2"
            />
            <path
                d="M43.2577 25.8133L40.5377 22.24C40.4844 22.1333 40.3777 22.0267 40.2177 21.9733L35.6844 20L35.0977 21.4933L37.871 22.72L28.1644 26.56L18.511 22.72L21.2844 21.4933L20.6444 20.0533L16.1644 22.0267C16.0577 22.08 15.951 22.1867 15.8444 22.2933L13.1244 25.8667L12.4844 26.72L14.6177 27.5733V35.8933L15.0977 36.1067L27.8977 41.6L28.2177 41.76L28.5377 41.6L41.3377 36.1067L41.8177 35.8933V27.52L43.951 26.6667L43.2577 25.8133ZM31.151 30.0267L29.4444 27.7867L39.631 23.7333L41.3377 25.9733L31.151 30.0267ZM16.6977 23.7333L19.7377 24.96L26.8844 27.7867L25.1777 30.0267L14.991 25.9733L16.6977 23.7333ZM16.1644 28.16L25.7644 31.9467L26.0844 31.4667L27.3644 29.76V39.5733L16.1644 34.7733V28.16ZM40.1644 34.7733L28.9644 39.5733V29.76L30.2444 31.4667L30.6177 31.9467L40.1644 28.16V34.7733Z"
                fill="#7E8CB2"
            />
        </g>
        <defs>
            <clipPath id="clip0_13649_173987">
                <path
                    d="M0.164062 28C0.164062 12.536 12.7001 0 28.1641 0V0C43.628 0 56.1641 12.536 56.1641 28V28C56.1641 43.464 43.628 56 28.1641 56V56C12.7001 56 0.164062 43.464 0.164062 28V28Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_173987">
                <rect width="32" height="32" fill="white" transform="translate(12.1641 12)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingErrorIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174050)">
            <path
                d="M0.260742 22C0.260742 10.402 9.66276 1 21.2607 1V1C32.8587 1 42.2607 10.402 42.2607 22V22C42.2607 33.598 32.8587 43 21.2607 43V43C9.66276 43 0.260742 33.598 0.260742 22V22Z"
                fill="#F9675D"
            />
            <circle cx="21.2607" cy="22" r="20" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174050)">
            <path
                d="M23.5406 16.0799L21.8606 17.7599V12.3999H20.6606V17.7599L18.9806 16.0799L18.1406 16.9199L20.8206 19.6399H21.7006L24.3806 16.9199L23.5406 16.0799Z"
                fill="#F9675D"
            />
            <path
                d="M32.581 20.36L30.541 17.68C30.501 17.6 30.421 17.52 30.301 17.48L26.901 16L26.461 17.12L28.541 18.04L21.261 20.92L14.021 18.04L16.101 17.12L15.621 16.04L12.261 17.52C12.181 17.56 12.101 17.64 12.021 17.72L9.98098 20.4L9.50098 21.04L11.101 21.68V27.92L11.461 28.08L21.061 32.2L21.301 32.32L21.541 32.2L31.141 28.08L31.501 27.92V21.64L33.101 21L32.581 20.36ZM23.501 23.52L22.221 21.84L29.861 18.8L31.141 20.48L23.501 23.52ZM12.661 18.8L14.941 19.72L20.301 21.84L19.021 23.52L11.381 20.48L12.661 18.8ZM12.261 22.12L19.461 24.96L19.701 24.6L20.661 23.32V30.68L12.261 27.08V22.12ZM30.261 27.08L21.861 30.68V23.32L22.821 24.6L23.101 24.96L30.261 22.12V27.08Z"
                fill="#F9675D"
            />
        </g>
        <circle cx="33.2607" cy="9" r="9" fill="#F9675D" />
        <path
            d="M33.6532 2.23193H32.9252L27.3252 13.4319L27.7172 14.0479H38.9172L39.3092 13.4319L33.6532 2.23193ZM28.3332 13.2079L33.2612 3.35193L38.1892 13.2079H28.3332Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M33.7091 6.26392H32.8691V10.1839H33.7091V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M33.7648 11.136H32.7568V12.144H33.7648V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174050">
                <path
                    d="M0.260742 22C0.260742 10.402 9.66276 1 21.2607 1V1C32.8587 1 42.2607 10.402 42.2607 22V22C42.2607 33.598 32.8587 43 21.2607 43V43C9.66276 43 0.260742 33.598 0.260742 22V22Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174050">
                <rect width="24" height="24" fill="white" transform="translate(9.26074 10)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingErrorBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174047)">
            <path
                d="M0.589844 29C0.589844 13.536 13.1259 1 28.5898 1V1C44.0538 1 56.5898 13.536 56.5898 29V29C56.5898 44.464 44.0538 57 28.5898 57V57C13.1259 57 0.589844 44.464 0.589844 29V29Z"
                fill="#F9675D"
            />
            <circle cx="28.5898" cy="29" r="27" fill="#FDF1F1" stroke="#F9675D" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174047)">
            <path
                d="M31.6297 21.1066L29.3897 23.3466V16.2H27.7897V23.3466L25.5497 21.1066L24.4297 22.2266L28.003 25.8533H29.1764L32.7497 22.2266L31.6297 21.1066Z"
                fill="#F9675D"
            />
            <path
                d="M43.6835 26.8133L40.9635 23.24C40.9102 23.1333 40.8035 23.0267 40.6435 22.9733L36.1102 21L35.5235 22.4933L38.2968 23.72L28.5902 27.56L18.9368 23.72L21.7102 22.4933L21.0702 21.0533L16.5902 23.0267C16.4835 23.08 16.3768 23.1867 16.2702 23.2933L13.5502 26.8667L12.9102 27.72L15.0435 28.5733V36.8933L15.5235 37.1067L28.3235 42.6L28.6435 42.76L28.9635 42.6L41.7635 37.1067L42.2435 36.8933V28.52L44.3768 27.6667L43.6835 26.8133ZM31.5768 31.0267L29.8702 28.7867L40.0568 24.7333L41.7635 26.9733L31.5768 31.0267ZM17.1235 24.7333L20.1635 25.96L27.3102 28.7867L25.6035 31.0267L15.4168 26.9733L17.1235 24.7333ZM16.5902 29.16L26.1902 32.9467L26.5102 32.4667L27.7902 30.76V40.5733L16.5902 35.7733V29.16ZM40.5902 35.7733L29.3902 40.5733V30.76L30.6702 32.4667L31.0435 32.9467L40.5902 29.16V35.7733Z"
                fill="#F9675D"
            />
        </g>
        <circle cx="47.5898" cy="9" r="9" fill="#F9675D" />
        <path
            d="M47.9823 2.23193H47.2543L41.6543 13.4319L42.0463 14.0479H53.2463L53.6383 13.4319L47.9823 2.23193ZM42.6623 13.2079L47.5903 3.35193L52.5183 13.2079H42.6623Z"
            fill="white"
            stroke="white"
            strokeWidth="0.2"
        />
        <path d="M48.0382 6.26392H47.1982V10.1839H48.0382V6.26392Z" fill="white" stroke="white" strokeWidth="0.2" />
        <path d="M48.0939 11.136H47.0859V12.144H48.0939V11.136Z" fill="white" stroke="white" strokeWidth="0.2" />
        <defs>
            <clipPath id="clip0_13649_174047">
                <path
                    d="M0.589844 29C0.589844 13.536 13.1259 1 28.5898 1V1C44.0538 1 56.5898 13.536 56.5898 29V29C56.5898 44.464 44.0538 57 28.5898 57V57C13.1259 57 0.589844 44.464 0.589844 29V29Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174047">
                <rect width="32" height="32" fill="white" transform="translate(12.5898 13)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingWarningIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174084)">
            <path
                d="M0.972656 22C0.972656 10.402 10.3747 1 21.9727 1V1C33.5706 1 42.9727 10.402 42.9727 22V22C42.9727 33.598 33.5706 43 21.9727 43V43C10.3747 43 0.972656 33.598 0.972656 22V22Z"
                fill="#ED9937"
            />
            <circle cx="21.9727" cy="22" r="20" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174084)">
            <path
                d="M24.2525 16.0799L22.5725 17.7599V12.3999H21.3725V17.7599L19.6925 16.0799L18.8525 16.9199L21.5325 19.6399H22.4125L25.0925 16.9199L24.2525 16.0799Z"
                fill="#ED9937"
            />
            <path
                d="M33.2929 20.36L31.2529 17.68C31.2129 17.6 31.1329 17.52 31.0129 17.48L27.6129 16L27.1729 17.12L29.2529 18.04L21.9729 20.92L14.7329 18.04L16.8129 17.12L16.3329 16.04L12.9729 17.52C12.8929 17.56 12.8129 17.64 12.7329 17.72L10.6929 20.4L10.2129 21.04L11.8129 21.68V27.92L12.1729 28.08L21.7729 32.2L22.0129 32.32L22.2529 32.2L31.8529 28.08L32.2129 27.92V21.64L33.8129 21L33.2929 20.36ZM24.2129 23.52L22.9329 21.84L30.5729 18.8L31.8529 20.48L24.2129 23.52ZM13.3729 18.8L15.6529 19.72L21.0129 21.84L19.7329 23.52L12.0929 20.48L13.3729 18.8ZM12.9729 22.12L20.1729 24.96L20.4129 24.6L21.3729 23.32V30.68L12.9729 27.08V22.12ZM30.9729 27.08L22.5729 30.68V23.32L23.5329 24.6L23.8129 24.96L30.9729 22.12V27.08Z"
                fill="#ED9937"
            />
        </g>
        <circle cx="36.2227" cy="7" r="6.75" fill="#FFB865" />
        <path
            d="M38.6163 5.87203C38.6163 4.52804 37.5243 3.43604 36.1803 3.43604C34.8363 3.43604 33.7443 4.52804 33.7443 5.87203V7.63603H32.7363V10.576H39.6663V7.63603H38.6163V5.87203ZM34.4163 5.87203C34.4163 4.90604 35.2143 4.10804 36.1803 4.10804C37.1463 4.10804 37.9443 4.90604 37.9443 5.87203V7.63603H34.4163V5.87203ZM39.0363 8.30803V9.98803H33.4083V8.30803H33.8283H38.6583H39.0363Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M36.5587 1.88208H35.9287V2.93208H36.5587V1.88208Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M40.4221 5.78809H39.3721V6.41809H40.4221V5.78809Z" fill="#623602" />
        <path d="M33.0725 5.78809H32.0225V6.41809H33.0725V5.78809Z" fill="#623602" />
        <path d="M39.1721 2.72214L38.4297 3.4646L38.8752 3.91007L39.6176 3.16762L39.1721 2.72214Z" fill="#623602" />
        <path d="M33.297 2.74203L32.8516 3.1875L33.594 3.92996L34.0395 3.48448L33.297 2.74203Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174084">
                <path
                    d="M0.972656 22C0.972656 10.402 10.3747 1 21.9727 1V1C33.5706 1 42.9727 10.402 42.9727 22V22C42.9727 33.598 33.5706 43 21.9727 43V43C10.3747 43 0.972656 33.598 0.972656 22V22Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174084">
                <rect width="24" height="24" fill="white" transform="translate(9.97266 10)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingWarningBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174081)">
            <path
                d="M0.300781 29C0.300781 13.536 12.8368 1 28.3008 1V1C43.7648 1 56.3008 13.536 56.3008 29V29C56.3008 44.464 43.7648 57 28.3008 57V57C12.8368 57 0.300781 44.464 0.300781 29V29Z"
                fill="#ED9937"
            />
            <circle cx="28.3008" cy="29" r="27" fill="#FFFAF1" stroke="#ED9937" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174081)">
            <path
                d="M31.3406 21.1066L29.1006 23.3466V16.2H27.5006V23.3466L25.2606 21.1066L24.1406 22.2266L27.714 25.8533H28.8873L32.4606 22.2266L31.3406 21.1066Z"
                fill="#ED9937"
            />
            <path
                d="M43.3944 26.8133L40.6744 23.24C40.6211 23.1333 40.5144 23.0267 40.3544 22.9733L35.8211 21L35.2344 22.4933L38.0078 23.72L28.3011 27.56L18.6478 23.72L21.4211 22.4933L20.7811 21.0533L16.3011 23.0267C16.1944 23.08 16.0878 23.1867 15.9811 23.2933L13.2611 26.8667L12.6211 27.72L14.7544 28.5733V36.8933L15.2344 37.1067L28.0344 42.6L28.3544 42.76L28.6744 42.6L41.4744 37.1067L41.9544 36.8933V28.52L44.0878 27.6667L43.3944 26.8133ZM31.2878 31.0267L29.5811 28.7867L39.7678 24.7333L41.4744 26.9733L31.2878 31.0267ZM16.8344 24.7333L19.8744 25.96L27.0211 28.7867L25.3144 31.0267L15.1278 26.9733L16.8344 24.7333ZM16.3011 29.16L25.9011 32.9467L26.2211 32.4667L27.5011 30.76V40.5733L16.3011 35.7733V29.16ZM40.3011 35.7733L29.1011 40.5733V30.76L30.3811 32.4667L30.7544 32.9467L40.3011 29.16V35.7733Z"
                fill="#ED9937"
            />
        </g>
        <circle cx="47.3008" cy="9" r="9" fill="#FFB865" />
        <path
            d="M50.4933 7.49605C50.4933 5.70405 49.0373 4.24805 47.2453 4.24805C45.4533 4.24805 43.9973 5.70405 43.9973 7.49605V9.84805H42.6533V13.768H51.8933V9.84805H50.4933V7.49605ZM44.8933 7.49605C44.8933 6.20805 45.9573 5.14405 47.2453 5.14405C48.5333 5.14405 49.5973 6.20805 49.5973 7.49605V9.84805H44.8933V7.49605ZM51.0533 10.744V12.984H43.5493V10.744H44.1093H50.5493H51.0533Z"
            fill="#623602"
            stroke="#623602"
            strokeWidth="0.2"
        />
        <path d="M47.7492 2.17603H46.9092V3.57603H47.7492V2.17603Z" fill="#623602" stroke="#623602" strokeWidth="0.2" />
        <path d="M52.901 7.38403H51.501V8.22403H52.901V7.38403Z" fill="#623602" />
        <path d="M43.1012 7.38403H41.7012V8.22403H43.1012V7.38403Z" fill="#623602" />
        <path d="M51.2341 3.29595L50.2441 4.28589L50.8381 4.87985L51.828 3.88991L51.2341 3.29595Z" fill="#623602" />
        <path d="M43.4006 3.32278L42.8066 3.91675L43.7966 4.90669L44.3905 4.31272L43.4006 3.32278Z" fill="#623602" />
        <defs>
            <clipPath id="clip0_13649_174081">
                <path
                    d="M0.300781 29C0.300781 13.536 12.8368 1 28.3008 1V1C43.7648 1 56.3008 13.536 56.3008 29V29C56.3008 44.464 43.7648 57 28.3008 57V57C12.8368 57 0.300781 44.464 0.300781 29V29Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174081">
                <rect width="32" height="32" fill="white" transform="translate(12.3008 13)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingSuccessIcon = () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174016)">
            <path
                d="M0.547852 22C0.547852 10.402 9.94987 1 21.5479 1V1C33.1458 1 42.5479 10.402 42.5479 22V22C42.5479 33.598 33.1458 43 21.5479 43V43C9.94987 43 0.547852 33.598 0.547852 22V22Z"
                fill="#93E191"
            />
            <circle cx="21.5479" cy="22" r="20" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174016)">
            <path
                d="M23.8277 16.0799L22.1477 17.7599V12.3999H20.9477V17.7599L19.2677 16.0799L18.4277 16.9199L21.1077 19.6399H21.9877L24.6677 16.9199L23.8277 16.0799Z"
                fill="#54C65F"
            />
            <path
                d="M32.8681 20.36L30.8281 17.68C30.7881 17.6 30.7081 17.52 30.5881 17.48L27.1881 16L26.7481 17.12L28.8281 18.04L21.5481 20.92L14.3081 18.04L16.3881 17.12L15.9081 16.04L12.5481 17.52C12.4681 17.56 12.3881 17.64 12.3081 17.72L10.2681 20.4L9.78809 21.04L11.3881 21.68V27.92L11.7481 28.08L21.3481 32.2L21.5881 32.32L21.8281 32.2L31.4281 28.08L31.7881 27.92V21.64L33.3881 21L32.8681 20.36ZM23.7881 23.52L22.5081 21.84L30.1481 18.8L31.4281 20.48L23.7881 23.52ZM12.9481 18.8L15.2281 19.72L20.5881 21.84L19.3081 23.52L11.6681 20.48L12.9481 18.8ZM12.5481 22.12L19.7481 24.96L19.9881 24.6L20.9481 23.32V30.68L12.5481 27.08V22.12ZM30.5481 27.08L22.1481 30.68V23.32L23.1081 24.6L23.3881 24.96L30.5481 22.12V27.08Z"
                fill="#54C65F"
            />
        </g>
        <circle cx="35.7979" cy="7" r="6.75" fill="#54C65F" />
        <path
            d="M38.7681 4.30005L34.4481 8.56605L32.8281 6.94605L32.2881 7.54005L34.4481 9.70005L39.3081 4.84005L38.7681 4.30005Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174016">
                <path
                    d="M0.547852 22C0.547852 10.402 9.94987 1 21.5479 1V1C33.1458 1 42.5479 10.402 42.5479 22V22C42.5479 33.598 33.1458 43 21.5479 43V43C9.94987 43 0.547852 33.598 0.547852 22V22Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174016">
                <rect width="24" height="24" fill="white" transform="translate(9.54785 10)" />
            </clipPath>
        </defs>
    </svg>
);
export const ProcessingSuccessBigIcon = () => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13649_174013)">
            <path
                d="M0.876953 29C0.876953 13.536 13.413 1 28.877 1V1C44.3409 1 56.877 13.536 56.877 29V29C56.877 44.464 44.3409 57 28.877 57V57C13.413 57 0.876953 44.464 0.876953 29V29Z"
                fill="#93E191"
            />
            <circle cx="28.877" cy="29" r="27" fill="#F1FFF6" stroke="#A7ECA5" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip1_13649_174013)">
            <path
                d="M31.9168 21.1066L29.6768 23.3466V16.2H28.0768V23.3466L25.8368 21.1066L24.7168 22.2266L28.2901 25.8533H29.4635L33.0368 22.2266L31.9168 21.1066Z"
                fill="#54C65F"
            />
            <path
                d="M43.9706 26.8133L41.2506 23.24C41.1973 23.1333 41.0906 23.0267 40.9306 22.9733L36.3973 21L35.8106 22.4933L38.5839 23.72L28.8773 27.56L19.2239 23.72L21.9973 22.4933L21.3573 21.0533L16.8773 23.0267C16.7706 23.08 16.6639 23.1867 16.5573 23.2933L13.8373 26.8667L13.1973 27.72L15.3306 28.5733V36.8933L15.8106 37.1067L28.6106 42.6L28.9306 42.76L29.2506 42.6L42.0506 37.1067L42.5306 36.8933V28.52L44.6639 27.6667L43.9706 26.8133ZM31.8639 31.0267L30.1573 28.7867L40.3439 24.7333L42.0506 26.9733L31.8639 31.0267ZM17.4106 24.7333L20.4506 25.96L27.5973 28.7867L25.8906 31.0267L15.7039 26.9733L17.4106 24.7333ZM16.8773 29.16L26.4773 32.9467L26.7973 32.4667L28.0773 30.76V40.5733L16.8773 35.7733V29.16ZM40.8773 35.7733L29.6773 40.5733V30.76L30.9573 32.4667L31.3306 32.9467L40.8773 29.16V35.7733Z"
                fill="#54C65F"
            />
        </g>
        <circle cx="47.877" cy="9" r="9" fill="#54C65F" />
        <path
            d="M51.8373 5.3999L46.0773 11.0879L43.9173 8.9279L43.1973 9.7199L46.0773 12.5999L52.5573 6.1199L51.8373 5.3999Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_13649_174013">
                <path
                    d="M0.876953 29C0.876953 13.536 13.413 1 28.877 1V1C44.3409 1 56.877 13.536 56.877 29V29C56.877 44.464 44.3409 57 28.877 57V57C13.413 57 0.876953 44.464 0.876953 29V29Z"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_13649_174013">
                <rect width="32" height="32" fill="white" transform="translate(12.877 13)" />
            </clipPath>
        </defs>
    </svg>
);

export const CanceledIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 259.75 259.78" fill="#F9675D" stroke="#F9675D">
        <defs>
            <clipPath id="clip1_14545_1779977" transform="translate(-20.6 -20.54)">
                <rect fill="none" x="77.64" y="71.08" width="145.41" height="158.71" />
            </clipPath>
        </defs>
        <circle fill="#fdf1f1" stroke="#F9675D" strokeWidth="8px" cx="129.5" cy="129.5" r="123" />
        <g clipPath="url(#clip1_14545_1779977)">
            <path
                d="M223,108.68a4.27,4.27,0,0,0-.4-1.77,3.88,3.88,0,0,0-2.7-2.13L152,71.84a4.05,4.05,0,0,0-3.5,0L79.91,105.08a4,4,0,0,0-2.27,3.46v83.58a4,4,0,0,0,2.27,3.6L148.48,229s0,0,.07,0a1,1,0,0,1,.3.13s.06,0,.13,0l.3.1.1,0c.1,0,.23,0,.33.07h.1l.44,0a2.08,2.08,0,0,0,.43,0h.1a1.3,1.3,0,0,0,.33-.07s.07,0,.1,0l.3-.1s.07,0,.14,0a1.3,1.3,0,0,0,.3-.13s0,0,.06,0l68.78-33.34a4,4,0,0,0,2.26-3.6V108.78a.09.09,0,0,1-.06-.1Zm-72.78-28.8,59.47,28.83-21.9,10.64L128.31,90.51Zm0,57.67L90.74,108.71l28.4-13.77,59.48,28.84Zm-64.57-22.4,60.57,29.36V219L85.64,189.59ZM154.21,219V144.51l28.44-13.8v19.47a4,4,0,0,0,8,0V126.81L215,115v74.44Zm0,0"
                transform="translate(-20.6 -20.54)"
            />
        </g>
        <path
            d="M54.27,229.49l61.89-55.77L214.68,85l22.46-20.24c4.79-4.31-2.3-11.37-7.07-7.07l-61.89,55.77L69.66,202.18,47.2,222.42c-4.79,4.31,2.3,11.37,7.07,7.07Z"
            transform="translate(-20.6 -20.54)"
        />
    </svg>
);

export const RejectedIcon = () => (
    <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
        <clipPath id="clippath">
            <path
                fill="none"
                d="m30,1.53h0c15.72,0,28.47,12.75,28.47,28.47h0c0,15.72-12.75,28.47-28.47,28.47h0c-15.72,0-28.47-12.75-28.47-28.47h0C1.53,14.28,14.28,1.53,30,1.53Z"
            />
        </clipPath>
        <g clipPath="url(#clippath)">
            <g>
                <path
                    fill="#f9675d"
                    d="m30,1.53h0c15.72,0,28.47,12.75,28.47,28.47h0c0,15.72-12.75,28.47-28.47,28.47h0c-15.72,0-28.47-12.75-28.47-28.47h0C1.53,14.28,14.28,1.53,30,1.53Z"
                />
                <circle fill="#fdf1f1" stroke="#f9675d" strokeWidth="2px" cx="30" cy="30" r="27.45" />
            </g>
        </g>
        <g>
            <path
                fill="#f9675d"
                strokeWidth="0px"
                d="m29.87,17.29c-2.57,0-5.01.64-7.19,1.93l.77-3.85-1.8-.26-1.28,6.29.77,1.16,6.29,1.28.39-1.93-4.24-.9c1.93-1.16,3.98-1.8,6.29-1.8,6.55,0,11.81,5.26,11.81,11.81s-5.26,11.81-11.81,11.81-11.81-5.26-11.81-11.81h-1.93c0,7.57,6.16,13.87,13.87,13.87s13.87-6.16,13.87-13.87-6.42-13.74-13.99-13.74Z"
            />
            <path
                fill="#f9675d"
                strokeWidth="0px"
                d="m34.62,26.28h-9.5v9.63h9.63v-9.63h-.13Zm-1.8,7.7h-5.78v-5.78h5.78v5.78Z"
            />
        </g>
        <polygon
            fill="#f9675d"
            strokeWidth="0px"
            points="50.24 12.17 12.27 50.14 10.87 48.73 48.83 10.77 50.24 12.17"
        />
    </svg>
);

export const NedMoreInfoIcon = () => (
    <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
        <defs>
            <clipPath id="clippath">
                <path
                    fill="none"
                    strokeWidth="0"
                    d="m30,2.1h0c15.73,0,28.49,12.76,28.49,28.49h0c0,15.73-12.76,28.49-28.49,28.49h0c-15.73,0-28.49-12.76-28.49-28.49h0C1.51,14.86,14.27,2.1,30,2.1Z"
                />
            </clipPath>
        </defs>
        <g clipPath="url(#clippath)">
            <g>
                <path
                    fill="#ed9937"
                    strokeWidth="0"
                    d="m30,2.1h0c15.73,0,28.49,12.76,28.49,28.49h0c0,15.73-12.76,28.49-28.49,28.49h0c-15.73,0-28.49-12.76-28.49-28.49h0C1.51,14.86,14.27,2.1,30,2.1Z"
                />
                <circle fill="#fffaf1" stroke="#ed9937" strokeWidth="2" cx="30" cy="30.59" r="27.13" />
            </g>
        </g>
        <circle fill="#ffb865" strokeWidth="0" cx="49.33" cy="10.24" r="9.16" />
        <path
            fill="#623602"
            stroke="#623602"
            strokeWidth=".2"
            d="m52.58,8.71c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3v2.39h-1.37v3.99h9.4v-3.99h-1.42v-2.39Zm-5.7,0c0-1.31,1.08-2.39,2.39-2.39s2.39,1.08,2.39,2.39v2.39h-4.79v-2.39Zm6.27,3.3v2.28h-7.64v-2.28h7.64Z"
        />
        <path fill="#623602" strokeWidth="0" d="m49.79,3.3h-.85v1.42h.85v-1.42Z" />
        <path fill="#623602" strokeWidth="0" d="m55.03,8.6h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m45.06,8.6h-1.42v.85h1.42v-.85Z" />
        <path fill="#623602" strokeWidth="0" d="m53.33,4.44l-1.01,1.01.6.6,1.01-1.01-.6-.6Z" />
        <path fill="#623602" strokeWidth="0" d="m45.36,4.47l-.6.6,1.01,1.01.6-.6-1.01-1.01Z" />
        <g>
            <polygon
                fill="#ed9937"
                strokeWidth="0"
                points="34.8 20.18 36.44 18.24 19.52 18.24 19.52 44.64 40.61 44.64 40.61 26.46 38.65 28.86 38.68 42.72 21.53 42.76 21.57 20.21 34.8 20.18"
            />
            <path
                fill="#ed9937"
                strokeWidth="0"
                d="m38.73,17.13l-10.38,12.32-1.57,6.76,6.54-2.7,10.31-12.26-4.9-4.11Zm-9.54,16.29l.64-2.68,1.9,1.59-2.54,1.09Zm3.88-2.54l-2.01-1.65,7.9-9.35,1.94,1.63-7.83,9.37Z"
            />
        </g>
    </svg>
);
